<template>
    <div class="order-page-container">
        <div style="background-color: #f5f5f5; padding: 10px; overflow-x: auto">
            <a-card class="page-card" :bordered="false" id="title-card">
                <template slot="title">
                    <a-breadcrumb separator=">">
                        <a-breadcrumb-item>
                            <router-link to="/cliente/monitores/cotacoes">
                                Home
                            </router-link>
                        </a-breadcrumb-item>

                        <a-breadcrumb-item class="order-page-title">
                            Diagnóstico
                        </a-breadcrumb-item>
                    </a-breadcrumb>
                </template>
                <template slot="extra">
                    <template>
                        <a-button
                            type="default"
                            @click="algorithmModalVisible = true"
                            style="margin-right: 4px"
                        >
                            <i class="fa-solid fa-sliders"></i> Configurar
                            Sugestão</a-button
                        >
                        <a-button
                            v-if="can('REQUEST', 'CREATE_RESUPPLY')"
                            @click="export_excel"
                            :loading="exportingExcel"
                            :disabled="exportingExcel"
                            style="margin-right: 4px"
                        >
                            <i
                                v-if="!exportingExcel"
                                class="fa-solid fa-file-excel"
                            ></i>
                            {{
                                exportingExcel ? "Gerando Excel..." : "Exportar"
                            }}
                        </a-button>
                        <a-button
                            type="default"
                            @click="syncListaProdutos"
                            style="margin-right: 4px"
                            :loading="syncing"
                        >
                            <i v-if="!syncing" class="fa-solid fa-sync"></i>
                            {{ !syncing ? "Sincronizar" : "Sincronizando" }}
                        </a-button>
                        <a-button
                            type="default"
                            @click="handleTotalizadores"
                            style="margin-right: 4px"
                            :hidden="!isDesktop"
                        >
                            <i class="fa-solid fa-calculator"></i>
                            {{
                                showTotalizadores
                                    ? "Ocultar Totalizadores"
                                    : "Mostrar Totalizadores"
                            }}
                        </a-button>
                        <a-button
                            type="danger"
                            @click="limparFiltros"
                            style="margin-right: 4px"
                            :hidden="!isDesktop"
                        >
                            <i class="fa-solid fa-filter-circle-xmark"></i>
                            Limpar Filtros
                        </a-button>
                        <a-button
                            @click="openSavedFilters"
                            style="margin-right: 4px"
                        >
                            <i class="fa-solid fa-bookmark"></i> Meus filtros
                        </a-button>
                        <a-button
                            type="primary"
                            @click="showDrawer"
                            style="margin-right: 4px"
                        >
                            <i class="fa-solid fa-filter"></i> Mais Filtros
                        </a-button>
                        <SavedFiltersModal
                            :visible="savedFiltersModalVisible"
                            screen="diagnosis"
                            :items="savedFilters"
                            :loading="savedFiltersLoading"
                            :active-id="activeSavedFilterId"
                            :active-modified="activeSavedFilterModified"
                            :get-payload="savedFilterPayload"
                            :range-fields="savedFilterRangeFields"
                            @close="savedFiltersModalVisible = false"
                            @apply="applySavedFilter"
                            @saved="markSavedFilterActive"
                            @changed="loadSavedFilters"
                        />
                    </template>
                </template>
                <a-alert
                    v-if="dataStatus && dataStatus.message"
                    type="warning"
                    show-icon
                    style="margin-bottom: 12px"
                >
                    <div
                        slot="message"
                        style="display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap"
                    >
                        <span>{{ dataStatus.message }}</span>
                        <a-button
                            size="small"
                            @click="$root.$emit('open-support-chat')"
                        >
                            <i class="fa-solid fa-headset" style="margin-right: 6px"></i>
                            Falar com o suporte
                        </a-button>
                    </div>
                </a-alert>
                <a-form
                    layout="vertical"
                    style="width: 100%"
                    @submit.prevent="getListaProdutos"
                >
                    <a-row :gutter="[12, 12]">
                        <!-- Busca -->
                        <a-col :xs="24" :sm="12" :md="8" :lg="4">
                            <a-input-group compact class="search-group">
                                <a-select
                                    v-model="selectedSearch"
                                    class="search-group-main"
                                    allow-clear
                                    placeholder="Filtro"
                                    :dropdown-style="{ minWidth: '200px' }"
                                >
                                    <a-select-option
                                        v-for="option in searchOptions"
                                        :key="option.key"
                                        :value="option.key"
                                    >
                                        {{ option.value }}
                                    </a-select-option>
                                </a-select>
                                <a-input
                                    v-model="filters.search"
                                    placeholder="Buscar"
                                    allow-clear
                                    class="search-group-letter"
                                    :disabled="!selectedSearch"
                                    @pressEnter="getListaProdutos"
                                />
                            </a-input-group>
                        </a-col>
                        <a-col :xs="24" :sm="12" :md="8" :lg="4">
                            <a-input-group compact class="curve-group">
                                <a-select
                                    v-model="selectedCurve"
                                    class="curve-group-main"
                                    :dropdown-style="{ minWidth: '200px' }"
                                >
                                    <a-select-option
                                        v-for="option in curveDisplayOptions"
                                        :key="option.key"
                                        :value="option.key"
                                    >
                                        {{ option.value }}
                                    </a-select-option>
                                </a-select>

                                <a-select
                                    v-model="filters.curvas"
                                    placeholder="Curva"
                                    class="curve-group-letter fixed-height-select"
                                    mode="multiple"
                                >
                                    <a-select-option
                                        v-for="option in curveOptions"
                                        :key="option"
                                        :value="option"
                                    >
                                        {{ option }}
                                    </a-select-option>
                                </a-select>
                            </a-input-group>
                        </a-col>
                        <a-col :xs="24" :sm="12" :md="8" :lg="3">
                            <a-select
                                v-model="filters.id_loja__in"
                                show-search
                                allow-clear
                                placeholder="Selecionar loja"
                                option-filter-prop="children"
                                :filter-option="filterSelectOption"
                                :dropdown-style="{ minWidth: '300px' }"
                                class="fixed-height-select"
                                mode="multiple"
                            >
                                <a-select-option
                                    v-for="loja in apiFilters.lojas"
                                    :key="loja.id_loja"
                                    :value="loja.id_loja"
                                >
                                    {{ loja.id_loja }} -
                                    {{ loja.loja_descricao }} -
                                    {{ formatCNPJ(loja.loja_cnpj) }}
                                </a-select-option>
                            </a-select>
                        </a-col>

                        <a-col :xs="24" :sm="12" :md="8" :lg="3">
                            <a-select
                                v-model="filters.fornecedores_cnpj__icontains"
                                show-search
                                allow-clear
                                placeholder="Selecionar fornecedor"
                                :filter-option="filterFornecedor"
                                :dropdown-style="{ minWidth: '500px' }"
                            >
                                <a-select-option
                                    v-for="fornecedor in fornecedoresOptions"
                                    :key="fornecedor.cnpj"
                                    :value="fornecedor.cnpj"
                                    :fornecedor="fornecedor"
                                >
                                    #{{ fornecedor.ids.join(", #") }} -
                                    {{ formatCNPJ(fornecedor.cnpj) }} -
                                    {{ fornecedor.nomes.join(" / ") }}
                                </a-select-option>
                            </a-select>
                        </a-col>
                        <a-col :xs="24" :sm="12" :md="8" :lg="3">
                            <a-select
                                v-model="filters.tipo_produto__in"
                                placeholder="Tipo do Produto"
                                allow-clear
                                style="width: 100%"
                                :dropdown-style="{ minWidth: '200px' }"
                                class="fixed-height-select"
                                mode="multiple"
                            >
                                <a-select-option
                                    v-for="tipo_produto in apiFilters.tipo_produto"
                                    :key="tipo_produto.key"
                                    :value="tipo_produto.key"
                                >
                                    {{ tipo_produto.value }}
                                </a-select-option>
                            </a-select>
                        </a-col>

                        <!-- STATUS -->
                        <a-col :xs="24" :sm="12" :md="8" :lg="2">
                            <a-select
                                v-model="filters.criticidade_reposicao__in"
                                placeholder="Status"
                                allow-clear
                                style="width: 100%"
                                mode="multiple"
                                class="fixed-height-select"
                                :dropdown-style="{ minWidth: '200px' }"
                            >
                                <a-select-option
                                    v-for="option in apiFilters.criticidade"
                                    :key="option.key"
                                    :value="option.key"
                                >
                                    {{ option.value }}
                                </a-select-option>
                            </a-select>
                        </a-col>
                        <a-col :xs="24" :sm="12" :md="8" :lg="3">
                            <a-tree-select
                                v-model="filters.mercadologico__in"
                                placeholder="Mercadológico"
                                allow-clear
                                show-search
                                tree-checkable
                                tree-node-filter-prop="title"
                                show-checked-strategy="SHOW_CHILD"
                                class="fixed-height-select"
                                :tree-data="apiFilters.mercadologico"
                                :dropdown-style="{ minWidth: '300px', maxHeight: '400px' }"
                            />
                        </a-col>
                        <a-col flex="auto" class="actions-col">
                            <a-form-item class="item-button">
                                <div class="actions-right">
                                    <a-button
                                        type="default"
                                        icon="search"
                                        @click="getListaProdutos"
                                    >
                                        Filtrar
                                    </a-button>
                                </div>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <div>
                        <AdvancedFiltersDrawer
                            :visible.sync="visible"
                            @apply="getListaProdutos"
                            @clear="limparFiltros"
                        >
                            <template slot="title">
                                <i class="fa-solid fa-filter"></i>
                                Filtros Avançados
                            </template>

                            <a-form layout="vertical" hide-required-mark>
                                <a-row :gutter="16">
                                    <!-- ULTIMA COMPRA -->
                                    <a-col :xs="24" :md="12">
                                        <a-form-item label="Última Entrada">
                                            <a-range-picker
                                                v-model="
                                                    filters.ultima_data_emissao
                                                "
                                                style="width: 100%"
                                                format="DD/MM/YYYY"
                                                :placeholder="['Início', 'Fim']"
                                                :ranges="ranges"
                                            />
                                        </a-form-item>
                                    </a-col>

                                    <!-- TENDENCIA -->
                                    <a-col :xs="24" :md="12">
                                        <a-form-item label="Tendência de Venda">
                                            <a-select
                                                v-model="
                                                    filters.tendencia_venda__in
                                                "
                                                placeholder="Selecione"
                                                allow-clear
                                                mode="multiple"
                                            >
                                                <a-select-option
                                                    v-for="option in apiFilters.tendencia"
                                                    :key="option.key"
                                                    :value="option.key"
                                                >
                                                    {{ option.value }}
                                                </a-select-option>
                                            </a-select>
                                        </a-form-item>
                                    </a-col>

                                    <!-- COMPRADOR -->
                                    <a-col :xs="24" :md="12">
                                        <a-form-item label="Comprador">
                                            <a-select
                                                v-model="filters.comprador__in"
                                                show-search
                                                allow-clear
                                                placeholder="Selecionar comprador"
                                                option-filter-prop="children"
                                                :filter-option="
                                                    filterSelectOption
                                                "
                                                mode="multiple"
                                            >
                                                <a-select-option
                                                    v-for="comprador in apiFilters.compradores"
                                                    :key="comprador.comprador"
                                                    :value="comprador.comprador"
                                                >
                                                    {{ comprador.comprador }}
                                                </a-select-option>
                                            </a-select>
                                        </a-form-item>
                                    </a-col>
                                    <!-- GRUPO -->
                                    <a-col :xs="24" :md="12">
                                        <a-form-item label="Grupo">
                                            <a-select
                                                v-model="filters.grupo__in"
                                                placeholder="Selecione"
                                                allow-clear
                                                show-search
                                                mode="multiple"
                                            >
                                                <a-select-option
                                                    v-for="item in apiFilters.grupo"
                                                    :key="item.grupo"
                                                    :value="item.grupo"
                                                >
                                                    {{ item.grupo }}
                                                </a-select-option>
                                            </a-select>
                                        </a-form-item>
                                    </a-col>
                                    <!-- COBERTURA -->
                                    <a-col :xs="24" :md="12">
                                        <RangeSliderFilter
                                            label="Cobertura"
                                            v-model="
                                                filters.cobertura_estoque_dias_range
                                            "
                                            :min="
                                                apiFilters.cobertura_range
                                                    ?.min ?? 0
                                            "
                                            :max="
                                                apiFilters.cobertura_range
                                                    ?.max ?? 100
                                            "
                                        />
                                    </a-col>

                                    <!-- ESTOQUE -->
                                    <a-col :xs="24" :md="12">
                                        <RangeSliderFilter
                                            label="Estoque"
                                            v-model="filters.estoque_range"
                                            :min="
                                                apiFilters.estoque_range?.min ??
                                                0
                                            "
                                            :max="
                                                apiFilters.estoque_range?.max ??
                                                100
                                            "
                                        />
                                    </a-col>

                                    <!-- DIAS ULTIMA VENDA -->
                                    <a-col :xs="24" :md="12">
                                        <RangeSliderFilter
                                            label="Dias desde a última venda"
                                            v-model="
                                                filters.dias_ultima_venda_range
                                            "
                                            :min="
                                                apiFilters
                                                    .dias_ultima_venda_range
                                                    ?.min ?? 0
                                            "
                                            :max="
                                                apiFilters
                                                    .dias_ultima_venda_range
                                                    ?.max ?? 100
                                            "
                                        />
                                    </a-col>
                                    <!-- SUGESTÃO RANGE -->
                                    <a-col :xs="24" :md="12">
                                        <RangeSliderFilter
                                            label="Sugestão"
                                            v-model="filters.sugestao_range"
                                            :min="
                                                apiFilters.sugestao_range
                                                    ?.min ?? 0
                                            "
                                            :max="
                                                apiFilters.sugestao_range
                                                    ?.max ?? 100
                                            "
                                        />
                                    </a-col>

                                    <a-col :xs="24" :md="12">
                                        <a-form-item label="Preset de colunas">
                                            <a-select
                                                v-model="selectedPreset"
                                                placeholder="Preset de colunas"
                                            >
                                                <a-select-option
                                                    v-for="(
                                                        preset, key
                                                    ) in columnPresets"
                                                    :key="key"
                                                    :value="key"
                                                >
                                                    {{
                                                        presetLabels[key] || key
                                                    }}
                                                </a-select-option>
                                            </a-select>
                                        </a-form-item>
                                    </a-col>

                                    <a-col :xs="24">
                                        <a-form-item label="Colunas Visíveis">
                                            <a-select
                                                v-model="selectedColumns"
                                                mode="multiple"
                                                placeholder="Selecione as colunas"
                                                style="width: 100%"
                                            >
                                                <a-select-option
                                                    v-for="col in selectableColumns"
                                                    :key="col.dataIndex"
                                                    :value="col.dataIndex"
                                                >
                                                    {{ col.title }}
                                                </a-select-option>
                                            </a-select>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </a-form>

                            <div
                                :style="{
                                    position: 'absolute',
                                    right: 0,
                                    bottom: 0,
                                    width: '100%',
                                    borderTop: '1px solid #e9e9e9',
                                    padding: '10px 16px',
                                    background: '#fff',
                                    textAlign: 'left',
                                    zIndex: 1,
                                }"
                            >
                                <a-button
                                    type="primary"
                                    @click="getListaProdutos"
                                    style="padding: 0 30px"
                                >
                                    <i class="fa-solid fa-magnifying-glass"></i>
                                    Filtrar
                                </a-button>

                                <a-button
                                    type="danger"
                                    @click="limparFiltros"
                                    style="margin-left: 8px; padding: 0 10px"
                                >
                                    <i
                                        class="fa-solid fa-filter-circle-xmark"
                                    ></i>
                                    Limpar Filtros
                                </a-button>

                                <a-button
                                    :style="{ marginLeft: '8px' }"
                                    @click="onClose"
                                >
                                    Fechar
                                </a-button>
                            </div>
                        </AdvancedFiltersDrawer>
                    </div>
                </a-form>

                <a-card
                    class="applied-filters-container"
                    :bordered="false"
                    v-if="hasAppliedFilters"
                >
                    <div class="applied-filters">
                        <span class="applied-filters-count">
                            <span v-if="!showAppliedFilters"
                                >{{ appliedFiltersCount }}
                                {{
                                    appliedFiltersCount > 1
                                        ? "configurações aplicadas"
                                        : "configuração aplicada"
                                }}
                            </span>
                        </span>
                        <a-tag
                            v-for="(value, key) in appliedFilters"
                            :key="key"
                            v-if="
                                isFilterActive(key, value) && showAppliedFilters
                            "
                            closable
                            class="filter-tag"
                            @close="removeFilter(key)"
                        >
                            <a-icon type="filter" class="filter-tag-icon" />

                            <span class="filter-tag-label">
                                {{ filterLabels[key] || key }}
                            </span>

                            <a-tooltip>
                                <template slot="title">
                                    <div
                                        v-for="(line, index) in filterTooltipLines(
                                            key,
                                            value
                                        )"
                                        :key="index"
                                    >
                                        {{ line }}
                                    </div>
                                </template>
                                <span class="filter-tag-value">
                                    {{ formatFilterValue(key, value) }}
                                </span>
                            </a-tooltip>
                        </a-tag>

                        <a-tag
                            v-for="(value, key) in algorithmFilters"
                            :key="key"
                            v-if="
                                isAlgorithmActive(key, value) &&
                                showAppliedFilters
                            "
                            closable
                            class="algorithm-tag"
                            @close="removeAlgorithm(key)"
                        >
                            <a-icon type="tool" class="filter-tag-icon" />

                            <span class="filter-tag-label">
                                {{ algorithmLabels[key] || key }}
                            </span>

                            <a-tooltip
                                :title="formatAlgorithmValue(key, value)"
                            >
                                <span class="filter-tag-value">
                                    {{ formatAlgorithmValue(key, value) }}
                                </span>
                            </a-tooltip>
                        </a-tag>
                        <div class="toggle-applied-filters">
                            <span
                                class="toggle-applied-filters-action"
                                @click="
                                    showAppliedFilters = !showAppliedFilters
                                "
                            >
                                {{ showAppliedFilters ? "Ocultar" : "Mostrar" }}
                            </span>
                        </div>
                    </div>
                </a-card>
            </a-card>

            <cc-loader-full v-if="is_loading_list" />
            <!-- <a-card class="page-card totals-card" :bordered="true"> -->
            <!-- <a-card style="background-color: #f5f5f5" :bordered="true"> -->

            <dashboard-stats
                :items="dashboardCards"
                @click="aplicarFiltroRapido"
                :showTotalizadores="showTotalizadores"
                :selectedKeys="filtrosRapidosSelecionados"
            />
            <!-- </a-card> -->

            <!--  -->
            <a-card
                class="page-card table-card"
                :bordered="false"
                :style="selectedRowKeys.length && { marginBottom: '60px' }"
            >
                <!-- tabela -->
                <div class="table-overflow table-container">
                    <a-table
                        size="small"
                        :columns="computedColumns"
                        :data-source="products"
                        :rowKey="getRowKey"
                        :loading="loading"
                        :pagination="pagination"
                        :scroll="{ x: 'max-content' }"
                        :row-selection="rowSelectionComputed"
                        class="diagnosis-table"
                        @change="handleTableChange"
                        :locale="{
                            emptyText: 'Nenhum Produto Encontrado.',
                            filterConfirm: 'Ok',
                            filterReset: 'Reset',
                        }"
                    >
                        <template slot="acoes" slot-scope="text, record">
                            <ActionMenu :actions="getActions(record)" />
                        </template>
                    </a-table>

                    <SelectionFooter :count="selectedRowKeys.length">
                        <template #summary>
                            Compra estimada:
                            <strong>
                                {{
                                    $options.filters.currency(
                                        selectedPurchaseValue
                                    )
                                }}
                            </strong>
                        </template>

                        <template #actions>
                            <a-button
                                type="warning"
                                size="large"
                                @click="clearSelection"
                            >
                                <span class="material-icons-round">
                                    clear
                                </span>

                                Limpar Seleção
                            </a-button>

                            <a-button
                                class="create_button"
                                size="large"
                                @click="openPurchaseModal"
                            >
                                <span class="material-icons-round">
                                    shopping_cart
                                </span>

                                Criar Requisição
                            </a-button>
                        </template>
                    </SelectionFooter>
                </div>
            </a-card>
        </div>
        <a-modal
            v-model="purchaseModalVisible"
            title="Criar requisição"
            :width="'95vw'"
            :height="'85vh'"
            centered
            class="purchase-modal"
            ok-text="Criar Requisição"
            cancel-text="Fechar"
            @ok="submitPurchaseRequest"
            :confirm-loading="purchaseSubmitting"
        >
            <div class="purchase-modal-layout">
                <!-- LEFT: TABLE -->
                <div class="purchase-modal-left">
                    <a-table
                        :showHeader="false"
                        :columns="purchaseStoreColumns"
                        :data-source="purchaseStores"
                        :pagination="false"
                        :expandedRowKeys="expandedRowKeys"
                        rowKey="storeId"
                        @expand="
                            (expanded, record) => {
                                this.expandedRowKeys = expanded
                                    ? [record.storeId]
                                    : [];
                            }
                        "
                    >
                        <template slot="expandedRowRender" slot-scope="record">
                            <a-table
                                :columns="purchaseProductColumns"
                                :data-source="record.items"
                                :pagination="{
                                    pageSize: 20,
                                    size: 'small',
                                }"
                                size="small"
                                rowKey="id_produto"
                                :scroll="{ y: 420 }"
                            >
                                <template
                                    slot="request_quantity"
                                    slot-scope="text, record, index"
                                >
                                    <a-input
                                        v-model="record.request_quantity"
                                        :min="0"
                                        style="width: 100%"
                                        data-field="qtd"
                                        class="request-quantity-input"
                                        @keydown="handleKeydown($event)"
                                        @input="
                                            handleRequestQuantityInput(
                                                $event,
                                                record
                                            )
                                        "
                                    />
                                </template>
                                <template
                                    slot="actions"
                                    slot-scope="text, record"
                                >
                                    <a-icon
                                        type="delete"
                                        style="cursor: pointer; color: red"
                                        @click="removeSelectedProduct(record)"
                                    />
                                </template>
                            </a-table>
                        </template>
                    </a-table>
                </div>

                <!-- RIGHT: SUMMARY -->
                <div class="purchase-modal-right">
                    <!-- CARD RESUMO GERAL -->
                    <!-- <div class="summary-card"> -->
                    <div class="summary-title">DADOS DA REQUISIÇÃO</div>
                    <div class="purchase-request-name">
                        <label class="purchase-request-label">
                            NOME DA REQUISIÇÃO
                        </label>

                        <a-input
                            v-model="request_name"
                            bordered="false"
                            class="purchase-request-input"
                        />
                    </div>
                    <div class="purchase-request-name">
                        <label class="purchase-request-label">
                            OBSERVAÇÃO
                        </label>

                        <a-textarea
                            :rows="4"
                            v-model="obs"
                            bordered="false"
                            class="purchase-request-input"
                        />
                    </div>

                    <div class="summary-title">RESUMO</div>

                    <div class="summary-item">
                        Lojas:
                        <strong>{{ purchaseStores.length }}</strong>
                    </div>

                    <div class="summary-item">
                        Itens:
                        <strong>{{ totalItems }}</strong>
                    </div>

                    <div class="summary-item">
                        Unidades:
                        <strong>{{ totalUnits }}</strong>
                    </div>

                    <div class="summary-item highlight">
                        Total estimado:
                        <strong>
                            {{ $options.filters.currency(totalEstimated) }}
                        </strong>
                    </div>
                    <!-- </div> -->

                    <!-- CARD POR LOJA -->
                    <!-- <div class="store-summary-card"> -->
                    <div class="summary-title">Por loja</div>

                    <div
                        v-for="store in purchaseStores"
                        :key="store.storeId"
                        class="store-summary-item"
                    >
                        <div>Loja {{ store.storeId }}</div>

                        <div>
                            <strong>
                                {{
                                    $options.filters.currency(store.totalValue)
                                }}
                            </strong>
                        </div>
                    </div>
                    <!-- </div> -->
                </div>
            </div>
        </a-modal>
        <HistoryModal
            v-if="is_history_modal_open"
            :productsList="visible_products()"
            :product="current_product"
            :storeNumber="selectedLoja"
            :clientId="client_id"
            :subrequest="subrequest"
            @close="is_history_modal_open = false"
            :hide_data="true"
        />
        <suggestion-algorithm-modal
            :value="algorithmFilters"
            :visible="algorithmModalVisible"
            @reset="resetFilters"
            @close="algorithmModalVisible = false"
            @save="saveAlgorithm"
        />
    </div>
</template>

<script>
import ModalSendListMobile from "@/components/cliente/monitors/ModalSendListMobile";
import ModalProductsListMobile from "@/components/cliente/monitors/ModalProductsListMobile";
import RequestService from "../../../services/v3/request.service";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import MobileNote from "@/components/notes/mobile-promotion.noteV2";
import StandardButton from "@/components/ui/buttons/Standard-Button.vue";
import StandardInput from "@/components/ui/inputs/StandardInput.vue";
import { typingRemoteRequestControlMixin } from "@/mixins/typing-remote-request-controls.mixin";
import { perm_mixin } from "@/mixins/permission.mixin";
import { mapGetters } from "vuex";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import AddProductModal from "@/modals/add-product/add-product.modal";
import Paginacao from "@/components/cliente/base-components/Pagination";
import Button from "@/components/ui/buttons/Standard-Button.vue";
// import Input from "@/components/ui/inputs/StandardInput.vue";
import CheckBox from "@/components/ui/inputs/StandardCheckBox.vue";
import * as CONSTANTS from "@/constants/constants";
import ProductBrandsModal from "@/modals/product-brands/product-brands.modal";
import NewProductModal from "@/modals/new-product/new-product.modal";
import ManageCategoriesModal from "@/modals/client/categories/manage-categories.modal";
import ProductService from "@/services/ProductService";
import StorageService from "@/services/local-storage.service";
import VarejoFacilService from "@/services/VarejoFacilService";
import RequestDetailsModal from "@/modals/products/request-details/request-details.modal";
import { mapState } from "vuex";
import ProductGroupService from "@/services/v3/management/ProductGroupService.js";
import HistoryModal from "@/components/partials/history-ant.modal.vue";
import StatsCards from "@/components/cliente/monitors/StatsCards.vue";
import SuggestionAlgorithmModal from "@/modals/diagnosis/SuggestionAlgorithmModal.vue";
import ActionMenu from "../../../components/popovers/action-menu.popover.vue";
import AdvancedFiltersDrawer from "../../../components/cliente/monitors/AdvancedFiltersDrawer.vue";
import RangeSliderFilter from "../../../components/cliente/monitors/RangeSliderFilter.vue";
import SelectionFooter from "../../../components/cliente/monitors/SelectionFooter.vue";
import SavedFiltersModal from "../../../components/cliente/monitors/SavedFiltersModal.vue";
import SavedFiltersService from "@/services/v3/saved-filters.service";
import {
    serializeDiagnosisState,
    restoreDiagnosisFilters,
    restoreDiagnosisColumns,
} from "@/helpers/saved-filters";

const defaultAlgorithmFilters = {
    estoque: "real",
    pendencia: "desconsiderar",
    cobertura: "tempo_compra",
    cobertura_dias: 30,
    giro: "ponderado",
    unidade: "unidade",
    exibicao: "todos",
};

export default {
    name: "DiagnosisTab",
    mixins: [typingRemoteRequestControlMixin, perm_mixin, loaderMixin],
    props: {
        subrequest: Object,
        filterProducts: String,
        setVarTotal: Function,
        positiveOnly: Boolean,
    },
    components: {
        HistoryModal,
        Paginacao,
        Button,
        "cc-request-details-modal": RequestDetailsModal,
        CheckBox,
        "new-product-modal": NewProductModal,
        "cc-product-brands-modal": ProductBrandsModal,
        "add-product-modal": AddProductModal,
        "cc-client-categories": ManageCategoriesModal,
        ModalSendListMobile,
        ModalProductsListMobile,
        MobileNote,
        StandardButton,
        StandardInput,
        "dashboard-stats": StatsCards,
        SuggestionAlgorithmModal,
        ActionMenu,
        AdvancedFiltersDrawer,
        RangeSliderFilter,
        SelectionFooter,
        SavedFiltersModal,
    },
    data() {
        return {
            showAppliedFilters: true,
            algorithmLabels: {
                estoque: "Estoque",
                pendencia: "Pendência",
                cobertura: "Cobertura",
                giro: "Giro",
                unidade: "Unidade",
                exibicao: "Exibição",
            },
            algorithmFilters: { ...defaultAlgorithmFilters },
            algorithmModalVisible: false,
            filtrosRapidosSelecionados: [],
            exportingExcel: false,
            syncing: false,
            dataStatus: null,
            dataStatusAlertShown: false,
            showTotalizadores: true,
            is_history_modal_open: false,
            selectedLoja: undefined,
            current_product: undefined,
            is_history_modal_open: false,
            ranges: {
                Hoje: [moment(), moment()],
                "Últimos 7 dias": [moment().subtract(7, "days"), moment()],
                "Últimos 30 dias": [moment().subtract(30, "days"), moment()],
                "Últimos 90 dias": [moment().subtract(90, "days"), moment()],
                "Esta Semana": [
                    moment().startOf("week"),
                    moment().endOf("week"),
                ],
                "Este Mês": [
                    moment().startOf("month"),
                    moment().endOf("month"),
                ],
                "Mês Passado": [
                    moment().subtract(1, "month").startOf("month"),
                    moment().subtract(1, "month").endOf("month"),
                ],
                "Este Ano": [moment().startOf("year"), moment()],
                // 'Próximo Mês': [moment().add(1, 'month').startOf('month'), moment().add(1, 'month').endOf('month')]
            },
            tipoFornecedor: undefined,
            selectedMap: {},
            lastRequestId: undefined,
            status_options: [
                { key: "SEM_VENDA", value: "Sem vendas" },
                { key: "EXCESSO", value: "Excesso" },
                { key: "BAIXO", value: "Baixo" },
                { key: "MODERADO", value: "Moderado" },
                { key: "ALTO", value: "Alto" },
                { key: "CRITICO", value: "Crítico" },
                { key: "RUPTURA", value: "Ruptura" },
            ],
            service: new RequestService(),
            purchaseSubmitting: false,
            purchaseModalVisible: false,
            purchaseItems: {},
            expandedRowKeys: [],
            selectedSearch: undefined,
            searchOptions: [
                { key: "EAN", value: "EAN" },
                { key: "produto_descricao", value: "Descrição" },
                { key: "id_produto", value: "Código Interno" },
            ],
            selectedCurve: "curva_abcd_faturamento_mercadologico",
            request_name: "Requisição automática",
            obs: undefined,
            curveDisplayOptions: [
                {
                    key: "curva_abc_faturamento_mercadologico",
                    value: "ABC Faturamento",
                },
                {
                    key: "curva_abcd_faturamento_mercadologico",
                    value: "ABCD Faturamento",
                },
                {
                    key: "curva_abc_quantidade_mercadologico",
                    value: "ABC Quantidade",
                },
                {
                    key: "curva_abcd_quantidade_mercadologico",
                    value: "ABCD Quantidade",
                },
            ],
            pagination: {
                current: 1,
                pageSize: 50,
                total: 0,
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50", "100"],
                locale: {
                    items_per_page: "/ página",
                },
                showTotal: (total, range) =>
                    `${range[0]}-${range[1]} de ${total} itens`,
                // showTotal: (total, range) => `${range[0]}-${range[1]}`,
            },
            visible: false,
            isDesktop: window.innerWidth >= 720,
            cancelSource: null,
            listMobileSelect: [],
            listMobileList: [],
            showSendListMobile: false,
            showProductListMobile: false,
            is_loading_list: false,
            nameListMobile: [],
            isAllCheck: false,
            mobileList: [],
            statusFilter: 8,
            products: [],
            arrayCategoria: [],
            editProductCategoryAndIntCode: true,
            showNewProductModal: true,
            showAddProductModal: true,
            showProductHistory: false,
            excludedOnly: false,
            show_product_request_details_modal: false,
            showClientCategoriesModal: true,
            showManagementProducts: false,
            showOptionSelect: false,
            addProduct: undefined,
            loading: true,
            loading2: false,
            checkAll: false,
            countAll: 0,
            countBuy: 0,
            countNever: 0,
            dateOrder: undefined,
            page: 1,
            totalPaginas: 1,
            buscaProduto: "",
            categoria: "",
            products: [],
            arrayCategoria: [],
            printProducts: [],
            items_by_page_value: 30,
            total_items: 1000,
            brands: null,
            current_product: {},
            current_info: null,
            buscaMarca: "",
            productsType: "all",
            manage_categories: false,
            product_service: new ProductService(),
            storage_svc: new StorageService(),
            vf_svc: new VarejoFacilService(),
            groupService: new ProductGroupService(),
            groups: [],
            new_product: null,
            show_add_product_modal: false,
            hidden_button_pdf: true,
            showEditBrandsModal: true,
            showProductLog: false,
            sorters: [],
            allColumns: [
                // PRODUTO
                {
                    title: "Loja",
                    dataIndex: "id_loja",
                    width: 50,
                    fixed: "left",
                    customRender: this.withTooltipColumn("Loja"),
                    sorter: true,
                },
                {
                    title: "ID",
                    dataIndex: "id_produto",
                    width: 60,
                    fixed: "left",
                    sorter: true,
                    customRender: this.withTooltipColumn("ID"),
                    className: "centered-column",
                },
                {
                    title: "Produto",
                    dataIndex: "produto_descricao",
                    width: 250,
                    fixed: "left",
                    ellipsis: true,
                    sorter: true,
                    customRender: this.withTooltipColumn("Produto"),
                },
                {
                    title: "EAN",
                    dataIndex: "ean",
                    width: 180,
                    sorter: true,
                    customRender: this.withTooltipColumn("EAN"),
                },
                {
                    title: "Mercadológico",
                    dataIndex: "mercadologico",
                    width: 120,
                    customRender: (value, row) =>
                        this.renderMercadologico(value, row),
                    sorter: true,
                },
                {
                    title: "Grupo",
                    dataIndex: "grupo",
                    width: 120,
                    sorter: true,
                },

                // VENDAS
                {
                    title: "Venda Total",
                    dataIndex: "total_venda",
                    width: 150,
                    customRender: (text) =>
                        this.$options.filters.currency(text),
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Qtd Venda",
                    dataIndex: "quantidade_venda",
                    width: 140,
                    customRender: (value) => Number(value).toFixed(2),
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "% Fat.",
                    dataIndex: "perc_faturamento",
                    width: 110,
                    customRender: (value) => `${(value * 100).toFixed(2)}%`,
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Curva ABC Fat.",
                    dataIndex: "curva_abc_faturamento",
                    width: 130,
                    sorter: true,
                },
                {
                    title: "Curva ABCD Fat.",
                    dataIndex: "curva_abcd_faturamento",
                    width: 140,
                    sorter: true,
                },
                {
                    title: "Giro Médio",
                    dataIndex: "giro_medio",
                    width: 90,
                    className: "centered-column",
                    customRender: (value, record) => {
                        const values = [
                            Number(record.giro_medio || 0).toFixed(2),
                            Number(record.giro_medio_90d || 0).toFixed(2),
                            Number(record.giro_medio_30d || 0).toFixed(2),
                            Number(record.giro_medio_14d || 0).toFixed(2),
                            Number(record.giro_medio_7d || 0).toFixed(2),
                        ];

                        const svgWidth = 30;
                        const svgHeight = 18;
                        const padding = 2;

                        const min = Math.min(...values);
                        const max = Math.max(...values);
                        const range = max - min || 1;

                        const points = values
                            .map((v, i) => {
                                const x =
                                    padding +
                                    (i * (svgWidth - padding * 2)) /
                                        (values.length - 1);
                                const y =
                                    svgHeight -
                                    padding -
                                    ((v - min) / range) *
                                        (svgHeight - padding * 2);
                                return `${x},${y}`;
                            })
                            .join(" ");

                        const giro = Number(record.giro_medio_ponderado);

                        let strokeColor = "#1890ff";

                        const color_dict = {
                            SEM_VENDA: "#bfbfbf",
                            CRESCIMENTO_ACELERADO: "#52c41a",
                            CRESCIMENTO: "#1890ff",
                            ESTAVEL: "#1890ff",
                            QUEDA: "#faad14",
                            QUEDA_ACELERADA: "#ff4d4f",
                        };

                        const tendencia_dict = {
                            SEM_VENDA: "Sem Venda",
                            CRESCIMENTO_ACELERADO: "Crescimento Acelerado",
                            CRESCIMENTO: "Crescimento",
                            ESTAVEL: "Estável",
                            QUEDA: "Queda",
                            QUEDA_ACELERADA: "Queda Acelerada",
                        };

                        strokeColor = color_dict[record.tendencia_venda];

                        return (
                            <a-tooltip
                                title={
                                    <div class="giro-tooltip">
                                        <div class="giro-tooltip-header">
                                            <span>Giro Ponderado</span>
                                            <strong>
                                                {Number(value).toFixed(2)}
                                            </strong>
                                        </div>
                                        <div>
                                            {record.tendencia_venda && (
                                                <span>
                                                    Tendência de Venda:{" "}
                                                    {
                                                        tendencia_dict[
                                                            record
                                                                .tendencia_venda
                                                        ]
                                                    }
                                                </span>
                                            )}
                                        </div>

                                        <div class="giro-tooltip-divider" />

                                        <table class="giro-tooltip-table">
                                            <thead>
                                                <tr>
                                                    <th>Período</th>
                                                    <th>Giro</th>
                                                    <th>Qtd</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {[
                                                    {
                                                        label: "Últimos 180 dias",
                                                        giro: record.giro_medio,
                                                        qtd: record.quantidade_venda,
                                                    },
                                                    {
                                                        label: "Últimos 90 dias",
                                                        giro: record.giro_medio_90d,
                                                        qtd: record.quantidade_total_90d,
                                                    },
                                                    {
                                                        label: "Últimos 30 dias",
                                                        giro: record.giro_medio_30d,
                                                        qtd: record.quantidade_total_30d,
                                                    },
                                                    {
                                                        label: "Últimos 14 dias",
                                                        giro: record.giro_medio_14d,
                                                        qtd: record.quantidade_total_14d,
                                                    },
                                                    {
                                                        label: "Últimos 7 dias",
                                                        giro: record.giro_medio_7d,
                                                        qtd: record.quantidade_total_7d,
                                                    },
                                                ].map((item) => (
                                                    <tr>
                                                        <td>{item.label}</td>
                                                        <td>
                                                            {Number(
                                                                item.giro || 0
                                                            ).toFixed(2)}
                                                        </td>
                                                        <td>{item.qtd || 0}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                }
                            >
                                <div class="giro-medio-cell">
                                    <span class="giro-ponderado-value">
                                        {Number(
                                            record.giro_medio_ponderado
                                        ).toFixed(2)}
                                    </span>

                                    <svg width={svgWidth} height={svgHeight}>
                                        <polyline
                                            fill="none"
                                            stroke={strokeColor}
                                            strokeWidth="1.8"
                                            points={points}
                                        />
                                    </svg>
                                </div>
                            </a-tooltip>
                        );
                    },
                    sorter: true,
                },
                {
                    title: "Cobertura Prevista",
                    dataIndex: "compra_sugestao_cobertura_prevista",
                    width: 90,
                    className: "centered-column",
                    sorter: true,
                    customRender: this.withTooltipColumn("Cobertura Prevista"),
                },
                {
                    title: "Dias c/ Venda",
                    dataIndex: "dias_com_venda",
                    width: 130,
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Dias s/ Venda",
                    dataIndex: "dias_sem_venda",
                    width: 130,
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Última Venda",
                    dataIndex: "ultima_data_venda",
                    width: 140,
                    className: "centered-column",
                    customRender: (value) => {
                        const date = this.$moment(value);

                        return value && value !== "NaT" && date.isValid()
                            ? date.format("DD/MM/YYYY")
                            : "-";
                    },
                    sorter: true,
                },

                // COMPRAS
                {
                    title: "Qtd Comprada",
                    dataIndex: "total_quantidade_compra",
                    width: 160,
                    customRender: (value) => Number(value).toFixed(2),
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Média Compra",
                    dataIndex: "media_quantidade_compra",
                    width: 150,
                    customRender: (value) => Number(value).toFixed(2),
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Últ. Compra",
                    dataIndex: "ultima_quantidade_compra",
                    width: 140,
                    customRender: (value) => Number(value).toFixed(2),
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Tempo Compras",
                    dataIndex: "tempo_entre_compras",
                    width: 140,
                    customRender: (value) => `${Number(value).toFixed(0)} dias`,
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Fornecedores",
                    dataIndex: "fornecedores_diferentes",
                    width: 120,
                    sorter: true,
                },

                // CUSTOS
                {
                    title: "Últ. Custo",
                    dataIndex: "ultimo_custo",
                    width: 130,
                    customRender: (text) =>
                        this.$options.filters.currency(text),
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Custo Médio",
                    dataIndex: "custo_medio",
                    width: 130,
                    customRender: (text) =>
                        this.$options.filters.currency(text),
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Custo Máx.",
                    dataIndex: "custo_maximo",
                    width: 130,
                    customRender: (text) =>
                        this.$options.filters.currency(text),
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Custo Mín.",
                    dataIndex: "custo_minimo",
                    width: 130,
                    customRender: (text) =>
                        this.$options.filters.currency(text),
                    className: "centered-column",
                    sorter: true,
                },

                // ESTOQUE
                {
                    title: "Estoque",
                    dataIndex: "estoque",
                    width: 100,
                    customRender: (value, record) => {
                        const temPendencia = record.pendencia > 0;
                        return (
                            <a-tooltip
                                title={
                                    <div>
                                        <div>
                                            Estoque mínimo:{" "}
                                            {record.estoque_minimo_ajustado}
                                        </div>
                                        <div>
                                            Ponto de Pedido:{" "}
                                            {record.ponto_pedido_ajustado}
                                        </div>
                                        <div>
                                            Estoque máximo:{" "}
                                            {record.estoque_maximo_ajustado}
                                        </div>
                                        <div>
                                            Estoque atual:{" "}
                                            {Number(value).toFixed(2)}
                                        </div>
                                        <div>
                                            Estoque estimado:{" "}
                                            {Number(
                                                record.estoque_estimado
                                            ).toFixed(2)}
                                        </div>
                                        {temPendencia && (
                                            <div>
                                                Pendência:{" "}
                                                {Number(
                                                    record.pendencia
                                                ).toFixed(2)}
                                            </div>
                                        )}
                                    </div>
                                }
                            >
                                <span style="display:inline-flex;align-items:center;">
                                    <span class="suggestion-column" />
                                    {Number(value).toFixed(2)}
                                    <span class="suggestion-column">
                                        {temPendencia && (
                                            <span
                                                class="material-symbols-outlined"
                                                style="color:#1677ff; fontSize: .8rem"
                                            >
                                                local_shipping
                                            </span>
                                        )}
                                    </span>
                                </span>
                            </a-tooltip>
                        );
                    },
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Estoque Estimado",
                    dataIndex: "estoque_estimado",
                    width: 130,
                    customRender: (value) => Number(value).toFixed(2),
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Valor Estoque",
                    dataIndex: "valor_estoque",
                    width: 160,
                    customRender: (text) =>
                        this.$options.filters.currency(text),
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Preço Venda",
                    dataIndex: "precovenda",
                    width: 130,
                    customRender: (text) =>
                        this.$options.filters.currency(text),
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Cobertura",
                    dataIndex: "cobertura_estoque_dias",
                    width: 90,
                    customHeaderCell: () => ({
                        style: {
                            textAlign: "center",
                        },
                    }),
                    customRender: (value, record) => {
                        const tempoEntreCompras = Number(
                            record.tempo_entre_compras || 0
                        );
                        const coberturaPrevista = Number(value || 0);

                        const percent = coberturaPrevista
                            ? Math.min(
                                  (coberturaPrevista / tempoEntreCompras) * 100,
                                  100
                              )
                            : 0;

                        let strokeColor = "#ff4d4f";

                        if (percent >= 30 && percent < 60) {
                            strokeColor = "#faad14";
                        }

                        if (percent >= 60) {
                            strokeColor = "#52c41a";
                        }

                        return (
                            <a-tooltip
                                title={
                                    <div>
                                        <div>
                                            Cobertura:{" "}
                                            {coberturaPrevista.toFixed(0)} dias
                                        </div>
                                        <div>
                                            Tempo entre compras:{" "}
                                            {tempoEntreCompras.toFixed(0)} dias
                                        </div>
                                        <div>
                                            {percent.toFixed(1)}% da cobertura
                                            ideal
                                        </div>
                                    </div>
                                }
                            >
                                <div class="centered-column">
                                    <div class="coverage-cell">
                                        <a-progress
                                            percent={percent}
                                            showInfo={false}
                                            strokeColor={strokeColor}
                                            size="small"
                                            class="coverage-progress"
                                        />

                                        <span class="coverage-text">
                                            {coberturaPrevista.toFixed(0)}d
                                        </span>
                                    </div>
                                </div>
                            </a-tooltip>
                        );
                    },
                    sorter: true,
                },
                {
                    title: "Est. Mín.",
                    dataIndex: "estoque_minimo_ajustado",
                    width: 130,
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Ponto Pedido",
                    dataIndex: "ponto_pedido_ajustado",
                    width: 140,
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Est. Máx.",
                    dataIndex: "estoque_maximo_ajustado",
                    width: 130,
                    className: "centered-column",
                    sorter: true,
                },

                // REPOSIÇÃO
                {
                    title: "Sug. Compra",
                    dataIndex: "compra_sugestao_ajustado",
                    width: 80,
                    className: "centered-column",
                    sorter: true,
                    customRender: (text, record) => {
                        const sugestao = Number(
                            record.compra_sugestao || 0
                        ).toFixed(2);
                        const sugestaoAjustada = Number(
                            record.compra_sugestao_ajustado || 0
                        );
                        const embalagem = Number(
                            record.quantidade_embalagem || 0
                        );

                        const menorQueCaixa =
                            embalagem > 0 &&
                            sugestao < embalagem &&
                            sugestaoAjustada > 0;

                        return (
                            <a-tooltip placement="top">
                                <template slot="title">
                                    <div class="tooltip-nowrap">
                                        <div>Sugestão: {sugestao}</div>
                                        <div>
                                            Sugestão ajustada:{" "}
                                            {sugestaoAjustada}
                                        </div>

                                        {embalagem > 0 && (
                                            <div>Embalagem: {embalagem} {record.unidade}</div>
                                        )}

                                        {menorQueCaixa && (
                                            <div style="margin-top:8px;color:#faad14;">
                                                Sugestão menor que uma caixa
                                            </div>
                                        )}
                                    </div>
                                </template>

                                <span style="display:inline-flex;align-items:center;">
                                    <span class="suggestion-column">
                                        {menorQueCaixa && (
                                            <i
                                                class="fa fa-triangle-exclamation"
                                                style="color:#faad14;"
                                            />
                                        )}
                                    </span>
                                    <span>{sugestaoAjustada}</span>

                                    <span class="suggestion-column" />
                                </span>
                            </a-tooltip>
                        );
                    },
                },
                {
                    title: "Status",
                    dataIndex: "criticidade_reposicao",
                    width: 60,
                    customRender: (value, record) => {
                        const config = {
                            RUPTURA: {
                                bg: "#fff1f0",
                                color: "#f5222d",
                                label: "Ruptura",
                            },

                            CRITICO: {
                                bg: "#fff7e6",
                                color: "#fa8c16",
                                label: "Critico",
                            },

                            ALTO: {
                                bg: "#e6f4ff",
                                color: "#1677ff",
                                label: "Alto",
                            },

                            BAIXO: {
                                bg: "#fffbe6",
                                color: "#d4b106",
                                label: "Baixo",
                            },

                            MODERADO: {
                                bg: "#f6ffed",
                                color: "#52c41a",
                                label: "Moderado",
                            },

                            NORMAL: {
                                bg: "#e6f4ff",
                                color: "#1677ff",
                                label: "Normal",
                            },

                            SEM_VENDA: {
                                bg: "#f9f0ff",
                                color: "#722ed1",
                                label: "Sem venda",
                            },

                            OBSOLETO: {
                                bg: "#434343",
                                color: "#f5f5f5",
                                label: "Obsoleto",
                            },

                            EXCESSO: {
                                bg: "#f5f5f5",
                                color: "#8c8c8c",
                                label: "Excesso",
                            },

                            NEGATIVO: {
                                bg: "#fff1f0",
                                color: "#a8071a",
                                label: "Negativo",
                            },
                        };

                        const current = config[value] || {
                            bg: "#f5f5f5",
                            color: "#595959",
                            label: value || "-",
                        };
                        const tagStyle = {
                            background: current.bg,
                            color: current.color,
                            border: "1px solid " + current.color,
                        };

                        const dotStyle = {
                            background: current.color,
                        };

                        const TIPO_RUPTURA_LABELS = {
                            PHANTOM: "Ruptura de Gôndola ou Fantasma",
                            SUPPLIER:
                                "Ruptura de Abastecimento (Logística / Fornecedor)",
                            SYSTEMIC:
                                "Ruptura Sistêmica (Estoque Negativo / Erro de Cadastro)",
                            COMMERCIAL: "Ruptura Comercial (Falta de Pedido)",
                        };

                        const tooltipConfig = {
                            RUPTURA: (record) => (
                                <div>
                                    <div>Produto em Ruptura.</div>
                                    {record.tipo_ruptura && (
                                        <div>
                                            Tipo de Ruptura:{" "}
                                            {TIPO_RUPTURA_LABELS[
                                                record.tipo_ruptura
                                            ] || record.tipo_ruptura}
                                        </div>
                                    )}
                                    <div>
                                        Probabilidade de ruptura:{" "}
                                        {(record.prob_ruptura * 100).toFixed(1)}
                                        %
                                    </div>
                                    <div>
                                        Dias desde a última venda:{" "}
                                        {Number(
                                            record.dias_ultima_venda
                                        ).toFixed(0)}
                                    </div>
                                    <div>
                                        Data da última venda:{" "}
                                        {this.$moment(
                                            record.ultima_data_venda
                                        ).format("DD/MM/YYYY")}
                                    </div>
                                </div>
                            ),

                            CRITICO: (record) => (
                                <div>
                                    <div>Estoque abaixo do nível mínimo.</div>
                                    <div>
                                        Estoque atual:{" "}
                                        {Number(record.estoque).toFixed(2)}
                                    </div>
                                    <div>
                                        Estoque mínimo:{" "}
                                        {Number(
                                            record.estoque_minimo_ajustado
                                        ).toFixed(2)}
                                    </div>
                                </div>
                            ),

                            BAIXO: (record) => (
                                <div>
                                    <div>Reposição recomendada.</div>
                                    <div>
                                        Estoque atual:{" "}
                                        {Number(record.estoque).toFixed(2)}
                                    </div>
                                    <div>
                                        Ponto de pedido:{" "}
                                        {Number(
                                            record.ponto_pedido_ajustado
                                        ).toFixed(2)}
                                    </div>
                                </div>
                            ),

                            NORMAL: (record) => (
                                <div>
                                    <div>
                                        Nível de estoque dentro da faixa
                                        recomendada.
                                    </div>
                                    <div>
                                        Estoque atual:{" "}
                                        {Number(record.estoque).toFixed(2)}
                                    </div>
                                    <div>
                                        Estoque máximo:{" "}
                                        {Number(
                                            record.estoque_maximo_ajustado
                                        ).toFixed(2)}
                                    </div>
                                </div>
                            ),

                            EXCESSO: (record) => (
                                <div>
                                    <div>Há excesso de estoque.</div>
                                    <div>
                                        Estoque atual:{" "}
                                        {Number(record.estoque).toFixed(2)}
                                    </div>
                                    <div>
                                        Estoque máximo:{" "}
                                        {Number(
                                            record.estoque_maximo_ajustado
                                        ).toFixed(2)}
                                    </div>
                                    <div>
                                        Quantidade em Excesso:{" "}
                                        {Number(
                                            record.quantidade_excesso
                                        ).toFixed(2)}
                                    </div>
                                    <div>
                                        Valor em Excesso: R${" "}
                                        {Number(record.valor_excesso).toFixed(
                                            2
                                        )}
                                    </div>
                                </div>
                            ),

                            SEM_VENDA: (record) => {
                                const hasValidDate =
                                    record.ultima_data_venda &&
                                    record.ultima_data_venda !== "NaT";

                                return (
                                    <div>
                                        {hasValidDate ? (
                                            <div>
                                                <div>
                                                    Produto há 60 dias ou mais
                                                    sem venda.
                                                </div>
                                                <div>
                                                    Dias desde a última venda:{" "}
                                                    {Number(
                                                        record.dias_ultima_venda
                                                    ).toFixed(0)}
                                                </div>

                                                <div>
                                                    Data da última venda:{" "}
                                                    {this.$moment(
                                                        record.ultima_data_venda
                                                    ).format("DD/MM/YYYY")}
                                                </div>
                                            </div>
                                        ) : (
                                            <div>
                                                Produto há 60 dias ou mais sem
                                                venda.
                                            </div>
                                        )}
                                    </div>
                                );
                            },

                            OBSOLETO: () => (
                                <div>
                                    <div>
                                        Produto sem nenhuma venda registrada
                                        nos últimos 180 dias.
                                    </div>
                                    <div>Sugestão de compra zerada.</div>
                                </div>
                            ),

                            NEGATIVO: (record) => (
                                <div>
                                    <div>Produto com Estoque Negativo.</div>
                                    <div>
                                        Estoque:{" "}
                                        {Number(record.estoque).toFixed(2)}
                                    </div>
                                </div>
                            ),
                        };

                        return (
                            <a-tooltip
                                class="status-tag"
                                style={tagStyle}
                                title={
                                    tooltipConfig[value]
                                        ? tooltipConfig[value](record)
                                        : value
                                }
                            >
                                <span
                                    class="status-dot"
                                    style={dotStyle}
                                ></span>

                                {current.label}
                            </a-tooltip>
                        );
                    },
                    sorter: true,
                },
                {
                    title: "Ação Comprador",
                    dataIndex: "acao_comprador",
                    width: 240,
                    sorter: true,
                },
                {
                    title: "Pendência",
                    dataIndex: "pendencia",
                    width: 90,
                    customRender: this.withTooltipColumn("Pendência", (value) =>
                        Number(value).toFixed(2)
                    ),
                    className: "centered-column",
                    sorter: true,
                },

                // EXCESSO
                {
                    title: "Qtd Excesso",
                    dataIndex: "quantidade_excesso",
                    width: 140,
                    customRender: (value) => Number(value).toFixed(2),
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Valor Excesso",
                    dataIndex: "valor_excesso",
                    width: 150,
                    customRender: (text) =>
                        this.$options.filters.currency(text),
                    className: "centered-column",
                    sorter: true,
                },

                {
                    title: "Emb.",
                    dataIndex: "quantidade_embalagem",
                    width: 90,
                    customRender: (value) => Number(value).toFixed(0),
                    sorter: true,
                },
                {
                    title: "Loja / Merc.",
                    dataIndex: "id_loja-mercadologico",
                    width: 180,
                    sorter: true,
                },

                // VENDAS ADICIONAIS
                {
                    title: "Primeira Venda",
                    dataIndex: "primeira_data_venda",
                    width: 150,
                    className: "centered-column",
                    customRender: (value) => {
                        const date = this.$moment(value);

                        return value && value !== "NaT" && date.isValid()
                            ? date.format("DD/MM/YYYY")
                            : "-";
                    },
                    sorter: true,
                },
                {
                    title: "Dias Últ. Venda",
                    dataIndex: "dias_ultima_venda",
                    width: 150,
                    customRender: (value) => `${Number(value).toFixed(0)} dias`,
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Dias Primeira Venda",
                    dataIndex: "dias_primeira_venda",
                    width: 170,
                    customRender: (value) => `${Number(value).toFixed(0)} dias`,
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "% Fat. Acum.",
                    dataIndex: "perc_faturamento_acum",
                    width: 140,
                    customRender: (value) => `${(value * 100).toFixed(2)}%`,
                    className: "centered-column",
                    sorter: true,
                },

                // CURVAS QUANTIDADE
                {
                    title: "% Quantidade",
                    dataIndex: "perc_quantidade",
                    width: 140,
                    customRender: (value) => `${(value * 100).toFixed(2)}%`,
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "% Qtd. Acum.",
                    dataIndex: "perc_quantidade_acum",
                    width: 140,
                    customRender: (value) => `${(value * 100).toFixed(2)}%`,
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Curva ABC Qtd.",
                    dataIndex: "curva_abc_quantidade",
                    width: 140,
                    sorter: true,
                },
                {
                    title: "Curva ABCD Qtd.",
                    dataIndex: "curva_abcd_quantidade",
                    width: 150,
                    sorter: true,
                },

                // COMPRAS ADICIONAIS
                {
                    title: "Qtd Notas",
                    dataIndex: "quantidade_notas",
                    width: 120,
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Primeira Compra",
                    dataIndex: "primeira_data_emissao",
                    width: 150,
                    customRender: (value) => {
                        const date = this.$moment(value);

                        return value && value !== "NaT" && date.isValid()
                            ? date.format("DD/MM/YYYY")
                            : "-";
                    },
                    className: "centered-column",
                    sorter: true,
                },

                // CURVAS MERCADOLÓGICO FATURAMENTO
                {
                    title: "% Fat. Merc.",
                    dataIndex: "perc_faturamento_mercadologico",
                    width: 150,
                    customRender: (value) => `${(value * 100).toFixed(2)}%`,
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "% Fat. Merc. Acum.",
                    dataIndex: "perc_faturamento_mercadologico_acum",
                    width: 180,
                    customRender: (value) => `${(value * 100).toFixed(2)}%`,
                    className: "centered-column",
                    sorter: true,
                },
                // CURVAS MERCADOLÓGICO QUANTIDADE
                {
                    title: "% Qtd. Merc.",
                    dataIndex: "perc_quantidade_mercadologico",
                    width: 150,
                    customRender: (value) => `${(value * 100).toFixed(2)}%`,
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "% Qtd. Merc. Acum.",
                    dataIndex: "perc_quantidade_mercadologico_acum",
                    width: 180,
                    customRender: (value) => `${(value * 100).toFixed(2)}%`,
                    className: "centered-column",
                    sorter: true,
                },
                // ESTOQUE / FINANCEIRO
                {
                    title: "Estoque Mín.",
                    dataIndex: "estoque_minimo",
                    width: 140,
                    customRender: (value) => Number(value).toFixed(2),
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Ponto Pedido",
                    dataIndex: "ponto_pedido",
                    width: 140,
                    customRender: (value) => Number(value).toFixed(2),
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Estoque Máx.",
                    dataIndex: "estoque_maximo",
                    width: 140,
                    customRender: (value) => Number(value).toFixed(2),
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "% Valor Est. Acum.",
                    dataIndex: "perc_valor_estoque_acum",
                    width: 170,
                    customRender: (value) => `${(value * 100).toFixed(2)}%`,
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "ABC Valor Est.",
                    dataIndex: "curva_abc_valor_estoque",
                    width: 150,
                    sorter: true,
                },
                {
                    title: "Valor Prev. Venda",
                    dataIndex: "valor_compra_prevista_venda",
                    width: 180,
                    customRender: (text) =>
                        this.$options.filters.currency(text),
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "% Prev. Venda Acum.",
                    dataIndex: "perc_valor_compra_prevista_venda_acum",
                    width: 190,
                    customRender: (value) => `${(value * 100).toFixed(2)}%`,
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "ABC Prev. Venda",
                    dataIndex: "curva_abc_valor_compra_prevista_venda",
                    width: 170,
                    sorter: true,
                },

                // CONTROLE
                {
                    title: "Index",
                    dataIndex: "__index_level_0__",
                    width: 100,
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Última Entrada",
                    dataIndex: "ultima_data_emissao",
                    width: 110,
                    customRender: (value, record) => {
                        const date = this.$moment(value);

                        const dataBase = record.ultima_entrada;

                        const formattedDate =
                            dataBase &&
                            dataBase !== "NaT" &&
                            this.$moment &&
                            this.$moment(dataBase).isValid()
                                ? this.$moment(dataBase).format("DD/MM/YYYY")
                                : "-";

                        const qtd = record?.ultima_quantidade_compra;
                        const preco = record?.ultimo_custo;
                        const vendas = record?.vendas_apos_ultima_entrada;

                        const precoFormatado =
                            preco != null
                                ? Number(preco).toLocaleString("pt-BR", {
                                      style: "currency",
                                      currency: "BRL",
                                  })
                                : "-";

                        return (
                            <a-tooltip
                                overlayClassName="tooltip-auto-width"
                                title={
                                    <div class="tooltip-nowrap">
                                        <div>
                                            Vendas últ. entrada: {vendas ?? "-"}
                                        </div>
                                        <div>
                                            Quantidade comprada: {qtd ?? "-"}
                                        </div>
                                        <div>
                                            Último custo: {precoFormatado}
                                        </div>
                                    </div>
                                }
                            >
                                <div style="line-height: 1.2; text-align: center;">
                                    <div>{formattedDate}</div>
                                </div>
                            </a-tooltip>
                        );
                    },
                    className: "centered-column",
                    sorter: true,
                },
                {
                    title: "Ações",
                    dataIndex: "acoes",
                    scopedSlots: { customRender: "acoes" },
                    fixed: "right",
                    sorter: false,
                    width: 60,
                    exportable: false,
                },
            ],
            columnPresets: {
                basico: [
                    "mercadologico",
                    "criticidade_reposicao",
                    "giro_medio",
                    "cobertura_estoque_dias",
                    "estoque",
                    "compra_sugestao_ajustado",
                    "compra_sugestao_cobertura_prevista",
                    "ultima_data_emissao",
                ],

                reposicao: [
                    "estoque",
                    "estoque_minimo_ajustado",
                    "ponto_pedido_ajustado",
                    "estoque_maximo_ajustado",
                    "compra_sugestao_ajustado",
                    "criticidade_reposicao",
                    "acao_comprador",
                    "pendencia",
                ],

                vendas: [
                    "total_venda",
                    "quantidade_venda",
                    "perc_faturamento",
                    "curva_abc_faturamento",
                    "curva_abcd_faturamento",
                    "giro_medio",
                    "ultima_data_venda",
                ],

                completo: "ALL",
            },

            presetLabels: {
                basico: "Básico",
                reposicao: "Reposição",
                vendas: "Vendas",
                completo: "Completo",
            },

            selectedPreset: "basico",

            selectedColumns: [],

            search: "",

            filters: {
                ean: undefined,
                produto_descricao: undefined,
                curva_abcd_faturamento_mercadologico: undefined,
                curva_abcd_quantidade_mercadologico: undefined,
                mercadologico: undefined,
                mercadologico__in: [],
                grupo: undefined,
                estoque: undefined,
                giro_medio: undefined,
                cobertura_estoque_dias: undefined,
                ultima_data_emissao: undefined,
                compra_sugestao_ajustado: undefined,
                criticidade_reposicao: undefined,
                search: undefined,
                provider: undefined,
                cobertura_estoque_dias_range: [],
                estoque_range: [],
                curvas: undefined,
                estoque__lte: undefined,
                criticidade_reposicao__in: [],
                loja: undefined,
                fornecedores_cnpj__icontains: undefined,
                comprador__in: undefined,
                dias_ultima_venda_range: [],
                sugestao_range: [],
                tipo_fornecedor: undefined,
            },
            appliedFilters: {},
            savedFilters: [],
            savedFiltersAvailable: false,
            savedFiltersLoading: false,
            savedFiltersModalVisible: false,
            activeSavedFilterId: null,
            activeSavedFilterSnapshot: null,
            filterLabels: {
                id_loja__in: "Loja",
                ean: "EAN",
                produto_descricao: "Produto",
                curva_abcd_faturamento_mercadologico:
                    "Curva ABCD (Faturamento)",
                curva_abcd_quantidade_mercadologico: "Curva ABCD (Quantidade)",
                mercadologico: "Mercadológico",
                mercadologico__in: "Mercadológico",
                grupo: "Grupo",
                grupo__in: "Grupo",
                estoque: "Estoque",
                estoque_range: "Faixa de Estoque",
                estoque__lte: "Estoque Máximo",
                giro_medio: "Giro Médio",
                cobertura_estoque_dias: "Cobertura (dias)",
                cobertura_estoque_dias_range: "Faixa de Cobertura",
                ultima_data_emissao: "Última Entrada",
                dias_ultima_venda_range: "Dias desde a Última Venda",
                compra_sugestao_ajustado: "Sugestão de Compra",
                sugestao_range: "Faixa de Sugestão",
                criticidade_reposicao: "Status",
                criticidade_reposicao__in: "Status",
                curvas: "Curvas",
                loja: "Loja",
                provider: "Fornecedor",
                fornecedores_cnpj__icontains: "CNPJ do Fornecedor",
                comprador__in: "Comprador",
                search: "Pesquisa",
                tipo_produto__in: "Tipo do Produto",
                tendencia_venda__in: "Tendência de Venda",
            },
            filterValueLabels: {},
            algorithmValueLabels: {
                estoque: {
                    real: "Real",
                    estimado: "Estimado",
                    desconsiderar: "Desconsiderar",
                },

                pendencia: {
                    desconsiderar: "Desconsiderar Pendência",
                    considerar: "Considerar Pendência",
                },

                cobertura: {
                    tempo_compra: "Tempo entre Compras",
                    cobertura_fixa: "Cobertura Fixa",
                },

                giro: {
                    ponderado: "Ponderado",
                    dias_7: "7 Dias",
                    dias_30: "30 Dias",
                    dias_90: "90 Dias",
                    dias_180: "180 Dias",
                },

                unidade: {
                    unidade: "Unidade",
                    unidade_compra: "Unidade de Compra",
                    ultima_compra: "Última Compra",
                },

                exibicao: {
                    todos: "Todos",
                    sugestao: "Apenas com Sugestão  ",
                },
            },
            mercadologicoLabels: {},
            usesMercadologicoIds: false,
            apiFilters: {
                lojas: [],
                fornecedores: [],
                mercadologico: [],
                grupo: [],
                compradores: [],
                criticidade: [],
                sugestao_range: [],
                tipo_produto: [],
            },
            selectedRowKeys: [],

            //MODAL:
            purchaseStoreColumns: [
                {
                    title: "Loja",
                    key: "store",
                    customRender: (text, record) =>
                        `Loja #${record.storeId} - ${
                            record.storeName
                        } - ${this.formatCNPJ(record.cnpj)}`,
                },

                {
                    title: "Itens",
                    dataIndex: "totalItems",
                    width: 120,
                    align: "right",
                    customRender: (value) => `${value} SKUs`,
                },

                {
                    title: "Valor estimado",
                    dataIndex: "totalValue",
                    align: "right",
                    customRender: (value) =>
                        this.$options.filters.currency(value),
                },
            ],
            purchaseProductColumns: [
                {
                    title: "Produto",
                    dataIndex: "produto_descricao",
                    width: 140,
                    sorter: (a, b) =>
                        (a.produto_descricao || "").localeCompare(
                            b.produto_descricao || ""
                        ),
                },

                {
                    title: "ID",
                    dataIndex: "id_produto",
                    width: 80,
                    sorter: (a, b) =>
                        (a.id_produto || "").localeCompare(b.id_produto || ""),
                    className: "centered-column",
                },

                {
                    title: "Giro Médio",
                    dataIndex: "giro_medio",
                    width: 90,
                    className: "centered-column",
                    customRender: (value, record) => {
                        const values = [
                            Number(record.giro_medio || 0).toFixed(2),
                            Number(record.giro_medio_90d || 0).toFixed(2),
                            Number(record.giro_medio_30d || 0).toFixed(2),
                            Number(record.giro_medio_14d || 0).toFixed(2),
                            Number(record.giro_medio_7d || 0).toFixed(2),
                        ];

                        const svgWidth = 30;
                        const svgHeight = 18;
                        const padding = 2;

                        const min = Math.min(...values);
                        const max = Math.max(...values);
                        const range = max - min || 1;

                        const points = values
                            .map((v, i) => {
                                const x =
                                    padding +
                                    (i * (svgWidth - padding * 2)) /
                                        (values.length - 1);
                                const y =
                                    svgHeight -
                                    padding -
                                    ((v - min) / range) *
                                        (svgHeight - padding * 2);
                                return `${x},${y}`;
                            })
                            .join(" ");

                        const giro = Number(record.giro_medio_ponderado);

                        let strokeColor = "#1890ff";

                        const color_dict = {
                            SEM_VENDA: "#bfbfbf",
                            CRESCIMENTO_ACELERADO: "#52c41a",
                            CRESCIMENTO: "#1890ff",
                            ESTAVEL: "#1890ff",
                            QUEDA: "#faad14",
                            QUEDA_ACELERADA: "#ff4d4f",
                        };

                        const tendencia_dict = {
                            SEM_VENDA: "Sem Venda",
                            CRESCIMENTO_ACELERADO: "Crescimento Acelerado",
                            CRESCIMENTO: "Crescimento",
                            ESTAVEL: "Estável",
                            QUEDA: "Queda",
                            QUEDA_ACELERADA: "Queda Acelerada",
                        };

                        strokeColor = color_dict[record.tendencia_venda];

                        return (
                            <a-tooltip
                                title={
                                    <div class="giro-tooltip">
                                        <div class="giro-tooltip-header">
                                            <span>Giro Ponderado</span>
                                            <strong>
                                                {Number(value).toFixed(2)}
                                            </strong>
                                        </div>
                                        <div>
                                            {record.tendencia_venda && (
                                                <span>
                                                    Tendência de Venda:{" "}
                                                    {
                                                        tendencia_dict[
                                                            record
                                                                .tendencia_venda
                                                        ]
                                                    }
                                                </span>
                                            )}
                                        </div>

                                        <div class="giro-tooltip-divider" />

                                        <table class="giro-tooltip-table">
                                            <thead>
                                                <tr>
                                                    <th>Período</th>
                                                    <th>Giro</th>
                                                    <th>Qtd</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {[
                                                    {
                                                        label: "Últimos 180 dias",
                                                        giro: record.giro_medio,
                                                        qtd: record.quantidade_venda,
                                                    },
                                                    {
                                                        label: "Últimos 90 dias",
                                                        giro: record.giro_medio_90d,
                                                        qtd: record.quantidade_total_90d,
                                                    },
                                                    {
                                                        label: "Últimos 30 dias",
                                                        giro: record.giro_medio_30d,
                                                        qtd: record.quantidade_total_30d,
                                                    },
                                                    {
                                                        label: "Últimos 14 dias",
                                                        giro: record.giro_medio_14d,
                                                        qtd: record.quantidade_total_14d,
                                                    },
                                                    {
                                                        label: "Últimos 7 dias",
                                                        giro: record.giro_medio_7d,
                                                        qtd: record.quantidade_total_7d,
                                                    },
                                                ].map((item) => (
                                                    <tr>
                                                        <td>{item.label}</td>
                                                        <td>
                                                            {Number(
                                                                item.giro || 0
                                                            ).toFixed(2)}
                                                        </td>
                                                        <td>{item.qtd || 0}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                }
                            >
                                <div class="giro-medio-cell">
                                    <span class="giro-ponderado-value">
                                        {Number(
                                            record.giro_medio_ponderado
                                        ).toFixed(2)}
                                    </span>

                                    <svg width={svgWidth} height={svgHeight}>
                                        <polyline
                                            fill="none"
                                            stroke={strokeColor}
                                            strokeWidth="1.8"
                                            points={points}
                                        />
                                    </svg>
                                </div>
                            </a-tooltip>
                        );
                    },
                    sorter: true,
                },

                {
                    title: "Últ. Qtd.",
                    dataIndex: "ultima_quantidade_compra",
                    width: 60,
                    className: "centered-column",

                    customRender: (value, record) => {
                        const qtd = Number(value || 0).toLocaleString("pt-BR", {
                            maximumFractionDigits: 0,
                        });

                        const dataBase =
                            record.ultima_entrada || record.ultima_data_emissao;

                        const formattedDate =
                            dataBase &&
                            dataBase !== "NaT" &&
                            this.$moment &&
                            this.$moment(dataBase).isValid()
                                ? this.$moment(dataBase).format("DD/MM/YYYY")
                                : "-";

                        const custo = this.$options?.filters?.currency
                            ? this.$options.filters.currency(
                                  record.ultimo_custo
                              )
                            : Number(record.ultimo_custo || 0).toLocaleString(
                                  "pt-BR",
                                  {
                                      style: "currency",
                                      currency: "BRL",
                                  }
                              );

                        return (
                            <a-tooltip
                                title={
                                    <div style="min-width: 180px">
                                        <div>Últ. custo: {custo}</div>
                                        <div>Últ. compra: {formattedDate}</div>
                                    </div>
                                }
                            >
                                <span>{qtd}</span>
                            </a-tooltip>
                        );
                    },

                    sorter: (a, b) =>
                        Number(a.ultima_quantidade_compra || 0) -
                        Number(b.ultima_quantidade_compra || 0),
                },

                {
                    title: "Pendência",
                    dataIndex: "pendencia",
                    width: 90,
                    customRender: this.withTooltipColumn("Pendência", (value) =>
                        Number(value).toFixed(2)
                    ),
                    className: "centered-column",
                    sorter: (a, b) =>
                        Number(a.pendencia || 0) - Number(b.pendencia || 0),
                },

                {
                    title: "Est.",
                    dataIndex: "estoque",
                    width: 100,
                    customRender: (value, record) => {
                        const temPendencia = record.pendencia > 0;
                        return (
                            <a-tooltip
                                title={
                                    <div>
                                        <div>
                                            Estoque mínimo:{" "}
                                            {record.estoque_minimo_ajustado}
                                        </div>
                                        <div>
                                            Ponto de Pedido:{" "}
                                            {record.ponto_pedido_ajustado}
                                        </div>
                                        <div>
                                            Estoque máximo:{" "}
                                            {record.estoque_maximo_ajustado}
                                        </div>
                                        <div>
                                            Estoque atual:{" "}
                                            {Number(value).toFixed(2)}
                                        </div>
                                        <div>
                                            Estoque estimado:{" "}
                                            {Number(
                                                record.estoque_estimado
                                            ).toFixed(2)}
                                        </div>
                                        {temPendencia && (
                                            <div>
                                                Pendência:{" "}
                                                {Number(
                                                    record.pendencia
                                                ).toFixed(2)}
                                            </div>
                                        )}
                                    </div>
                                }
                            >
                                <span style="display:inline-flex;align-items:center;">
                                    <span class="suggestion-column" />
                                    {Number(value).toFixed(2)}
                                    <span class="suggestion-column">
                                        {temPendencia && (
                                            <span
                                                class="material-symbols-outlined"
                                                style="color:#1677ff; fontSize: .8rem"
                                            >
                                                local_shipping
                                            </span>
                                        )}
                                    </span>
                                </span>
                            </a-tooltip>
                        );
                    },
                    className: "centered-column",
                    sorter: true,
                },

                {
                    title: "Sugestão",
                    dataIndex: "compra_sugestao_ajustado",
                    width: 60,
                    className: "centered-column",
                    sorter: (a, b) =>
                        Number(a.compra_sugestao_ajustado || 0) -
                        Number(b.compra_sugestao_ajustado || 0),
                    customRender: (text, record) => {
                        const sugestao = Number(
                            record.compra_sugestao || 0
                        ).toFixed(2);
                        const sugestaoAjustada = Number(
                            record.compra_sugestao_ajustado || 0
                        );
                        const embalagem = Number(
                            record.quantidade_embalagem || 0
                        );

                        const menorQueCaixa =
                            embalagem > 0 &&
                            sugestao < embalagem &&
                            sugestaoAjustada > 0;

                        return (
                            <a-tooltip placement="top">
                                <template slot="title">
                                    <div class="tooltip-nowrap">
                                        <div>Sugestão: {sugestao}</div>
                                        <div>
                                            Sugestão ajustada:{" "}
                                            {sugestaoAjustada}
                                        </div>

                                        {embalagem > 0 && (
                                            <div>Embalagem: {embalagem} {record.unidade}</div>
                                        )}

                                        {menorQueCaixa && (
                                            <div style="margin-top:8px;color:#faad14;">
                                                Sugestão menor que uma caixa
                                            </div>
                                        )}
                                    </div>
                                </template>

                                <span style="display:inline-flex;align-items:center;">
                                    <span class="suggestion-column" />
                                    <span>{sugestaoAjustada}</span>

                                    <span class="suggestion-column">
                                        {menorQueCaixa && (
                                            <i
                                                class="fa fa-triangle-exclamation"
                                                style="color:#faad14;"
                                            />
                                        )}
                                    </span>
                                </span>
                            </a-tooltip>
                        )
                    }
                },

                {
                    title: 'Emb.',
                    dataIndex: 'quantidade_embalagem',
                    width: 90,
                    customRender: (value, record) =>
                        `${Number(value || 0).toFixed(0)} ${record.unidade || ''}`.trim(),
                    className: "centered-column",
                    sorter: (a, b) =>
                        Number(a.quantidade_embalagem || 0) - Number(b.quantidade_embalagem || 0)
                },

                {
                    title: "Qtd.",
                    dataIndex: "request_quantity",
                    width: 40,
                    scopedSlots: {
                        customRender: "request_quantity",
                    },
                },
                {
                    title: "Cobertura",
                    dataIndex: "cobertura_estoque_dias",
                    width: 90,
                    customHeaderCell: () => ({
                        style: {
                            textAlign: "center",
                        },
                    }),
                    customRender: (value, record) => {
                        const tempoEntreCompras = Number(
                            record.tempo_entre_compras || 0
                        );
                        const coberturaPrevista = Number(value || 0);

                        const percent = coberturaPrevista
                            ? Math.min(
                                  (coberturaPrevista / tempoEntreCompras) * 100,
                                  100
                              )
                            : 0;

                        let strokeColor = "#ff4d4f";

                        if (percent >= 30 && percent < 60) {
                            strokeColor = "#faad14";
                        }

                        if (percent >= 60) {
                            strokeColor = "#52c41a";
                        }

                        return (
                            <a-tooltip
                                title={
                                    <div>
                                        <div>
                                            Cobertura:{" "}
                                            {coberturaPrevista.toFixed(0)} dias
                                        </div>
                                        <div>
                                            Tempo entre compras:{" "}
                                            {tempoEntreCompras.toFixed(0)} dias
                                        </div>
                                        <div>
                                            {percent.toFixed(1)}% da cobertura
                                            ideal
                                        </div>
                                    </div>
                                }
                            >
                                <div class="centered-column">
                                    <div class="coverage-cell">
                                        <a-progress
                                            percent={percent}
                                            showInfo={false}
                                            strokeColor={strokeColor}
                                            size="small"
                                            class="coverage-progress"
                                        />

                                        <span class="coverage-text">
                                            {coberturaPrevista.toFixed(0)}d
                                        </span>
                                    </div>
                                </div>
                            </a-tooltip>
                        );
                    },
                    sorter: true,
                },

                {
                    title: "Cobertura Prevista",
                    dataIndex: "cobertura_prevista",
                    width: 90,
                    customHeaderCell: () => ({
                        style: {
                            textAlign: "center",
                        },
                    }),
                    customRender: (value, record) => {
                        const tempoEntreCompras = Number(
                            record.tempo_entre_compras || 0
                        );
                        const coberturaAtual = Number(
                            record.cobertura_estoque_dias || 0
                        );

                        const coberturaPrevista = Number(
                            value ??
                                record.compra_sugestao_cobertura_prevista ??
                                coberturaAtual
                        );

                        const coberturaExibida =
                            Number(record.request_quantity || 0) > 0
                                ? coberturaPrevista
                                : coberturaAtual;

                        const percent = tempoEntreCompras
                            ? Math.min(
                                  (coberturaExibida / tempoEntreCompras) * 100,
                                  100
                              )
                            : 100;

                        let strokeColor = "#ff4d4f";

                        if (percent >= 30 && percent < 60) {
                            strokeColor = "#faad14";
                        }

                        if (percent >= 60) {
                            strokeColor = "#52c41a";
                        }

                        return (
                            <a-tooltip
                                title={
                                    <div>
                                        <div>
                                            Cobertura prevista:{" "}
                                            {coberturaPrevista.toFixed(0)} dias
                                        </div>
                                        <div>
                                            Tempo entre compras:{" "}
                                            {tempoEntreCompras.toFixed(0)} dias
                                        </div>
                                        <div>
                                            {percent.toFixed(1)}% da cobertura
                                            ideal
                                        </div>
                                    </div>
                                }
                            >
                                <div class="centered-column">
                                    <div class="coverage-cell">
                                        <a-progress
                                            percent={percent}
                                            showInfo={false}
                                            strokeColor={strokeColor}
                                            size="small"
                                            class="coverage-progress"
                                        />

                                        <span class="coverage-text">
                                            {coberturaPrevista.toFixed(0)}d
                                        </span>
                                    </div>
                                </div>
                            </a-tooltip>
                        );
                    },
                    sorter: (a, b) =>
                        Number(
                            a.cobertura_prevista ||
                                a.compra_sugestao_cobertura_prevista ||
                                a.cobertura_estoque_dias ||
                                0
                        ) -
                        Number(
                            b.cobertura_prevista ||
                                b.compra_sugestao_cobertura_prevista ||
                                b.cobertura_estoque_dias ||
                                0
                        ),
                },

                {
                    title: "Ações",
                    key: "actions",
                    width: 60,
                    className: "centered-column",
                    scopedSlots: {
                        customRender: "actions",
                    },
                },
            ],
            kpis: {},
            fornecedores: [],
        };
    },
    methods: {
        getActions(record) {
            return [
                {
                    label: "Histórico",
                    icon: "query_stats",
                    iconClass: "action-primary",
                    onClick: () => this.openHistoryModal(record),
                },
            ];
        },
        formatAlgorithmValue(key, value) {
            const options = this.algorithmValueLabels[key];

            let label = options ? options[value] || value : value;

            if (key === "cobertura" && value === "cobertura_fixa") {
                label += ` (${this.algorithmFilters.cobertura_dias} dias)`;
            }

            return label;
        },
        getDefaultAlgorithmFilters() {
            return {
                estoque: "real",
                pendencia: "desconsiderar",
                cobertura: "tempo_compra",
                cobertura_dias: 30,
                giro: "ponderado",
                unidade: "unidade",
                exibicao: "todos",
            };
        },
        removeAlgorithm(key) {
            const defaults = this.getDefaultAlgorithmFilters();

            if (defaults[key] !== undefined) {
                this.$set(this.algorithmFilters, key, defaults[key]);
            }

            this.getListaProdutos();
        },
        isAlgorithmActive(key, value) {
            if (key === "cobertura_dias") {
                return false;
            }

            const defaultValue = this.getDefaultAlgorithmFilters()[key];

            return value !== defaultValue;
        },
        formatFilterValue(key, value) {
            const apiMaps = {
                criticidade_reposicao__in: this.apiFilters.criticidade,
                tipo_produto: this.apiFilters.tipo_produto,
                tendencia_venda__in: this.apiFilters.tendencia,
            };

            if (apiMaps[key]) {
                const map = Object.fromEntries(
                    apiMaps[key].map((item) => [item.key, item.value])
                );
                return Array.isArray(value)
                    ? value
                          .map((v) => map[String(v).toUpperCase()] || v)
                          .join(", ")
                    : map[String(value).toUpperCase()] || value;
            }

            if (key === "mercadologico__in") {
                const labels = this.mercadologicoAppliedLabels(value);

                return labels.length > 1
                    ? `${labels[0]} +${labels.length - 1}`
                    : labels[0] || "";
            }

            // Datas
            if (key === "ultima_data_emissao" && value) {
                return [
                    this.$moment(value[0]).format("DD/MM/YYYY"),
                    this.$moment(value[1]).format("DD/MM/YYYY"),
                ].join(" ~ ");
            }

            return Array.isArray(value) ? value.join(", ") : value;
        },
        isFilterActive(key, value) {
            if (Array.isArray(value)) {
                if (key.endsWith("_range")) {
                    const defaultValue = this.getDefaultFilterValue(key);

                    return (
                        value.length === 2 &&
                        (value[0] !== defaultValue[0] ||
                            value[1] !== defaultValue[1])
                    );
                }
                return value.length > 0;
            }

            return value !== undefined && value !== null && value !== "";
        },
        getDefaultFilterValue(key) {
            const defaults = {
                cobertura_estoque_dias_range: [
                    this.apiFilters?.cobertura_range?.min,
                    this.apiFilters?.cobertura_range?.max,
                ],
                estoque_range: [
                    this.apiFilters?.estoque_range?.min,
                    this.apiFilters?.estoque_range?.max,
                ],
                dias_ultima_venda_range: [
                    this.apiFilters?.dias_ultima_venda_range?.min,
                    this.apiFilters?.dias_ultima_venda_range?.max,
                ],
                sugestao_range: [
                    this.apiFilters?.sugestao_range?.min,
                    this.apiFilters?.sugestao_range?.max,
                ],
                criticidade_reposicao__in: [],
            };

            return key in defaults ? defaults[key] : undefined;
        },

        removeFilter(key) {
            this.$set(this.filters, key, this.getDefaultFilterValue(key));

            this.getListaProdutos();
        },
        async saveAlgorithm() {
            const selectedItems = Object.values(this.selectedMap);

            if (!selectedItems.length) {
                this.algorithmModalVisible = false;
                this.getListaProdutos();
                return;
            }

            const result = await this.$swal({
                icon: "question",
                title: "Atualizar sugestões?",
                html: `
                    Existem produtos já selecionados.<br><br>
                    <b>Deseja recalcular a sugestão desses produtos utilizando o novo algoritmo?</b>
                `,
                showCancelButton: true,
                showDenyButton: true,
                confirmButtonText: "Recalcular",
                denyButtonText: "Manter atuais",
                cancelButtonText: "Cancelar",
                reverseButtons: true,
            });

            if (result.dismiss) {
                return;
            }

            if (result.isConfirmed) {
                try {
                    this.$swal({
                        title: "Recalculando sugestões...",
                        text: "Aguarde enquanto atualizamos os produtos selecionados.",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                        },
                    });

                    const cli_id = this.client_id;

                    const params = {
                        id_produto__in: this.buildInParam(
                            selectedItems.map((item) => item.id_produto)
                        ),
                        id_loja__in: this.buildInParam(
                            selectedItems.map((item) => item.id_loja)
                        ),
                        ...this.buildAlgorithmFiltersParams(),
                    };

                    const { data } = await axios.get(
                        `${
                            process.env.VUE_APP_MIRAI_BASE_URL ||
                            "https://api-integration.clubdacotacao.com.br/v3/intelligence"
                        }/diagnostics/${
                            process.env.VUE_APP_MIRAI_CLI_ID || cli_id
                        }`,
                        {
                            params,
                        }
                    );

                    const updatedMap = new Map(
                        (data.records || []).map((item) => [
                            `${item.id_produto}_${item.id_loja}`,
                            item,
                        ])
                    );

                    Object.keys(this.selectedMap).forEach((key) => {
                        const item = this.selectedMap[key];

                        const updated = updatedMap.get(
                            `${item.id_produto}_${item.id_loja}`
                        );

                        if (updated) {
                            this.$set(this.selectedMap, key, {
                                ...item,
                                ...updated,
                            });
                        }
                    });

                    if (this.purchaseModalVisible) {
                        this.openPurchaseModal();
                    }

                    await this.$swal({
                        icon: "success",
                        title: "Sugestões atualizadas!",
                        text: "Os produtos selecionados foram recalculados com sucesso.",
                    });
                } catch (err) {
                    console.error(err);

                    this.$swal({
                        icon: "error",
                        title: "Erro",
                        text: "Não foi possível atualizar as sugestões dos produtos selecionados.",
                    });

                    return;
                }
            }

            this.algorithmModalVisible = false;
            this.getListaProdutos();
        },
        filterFornecedor(input, option) {
            const fornecedor = option.data.attrs.fornecedor;
            if (!fornecedor) return false;

            const termo = input.toLowerCase().trim();

            const buscaId = termo.startsWith("#");
            const termoNumerico = termo.replace(/\D/g, "");

            const encontrouNome =
                termo &&
                fornecedor.nomes.some((nome) =>
                    nome.toLowerCase().includes(termo)
                );

            const encontrouId =
                buscaId &&
                termoNumerico &&
                fornecedor.ids.some((id) =>
                    String(id).startsWith(termoNumerico)
                );

            const cnpj = String(fornecedor.cnpj)
                .replace(/\D/g, "")
                .padStart(14, "0");

            const encontrouCnpj =
                !buscaId && termoNumerico && cnpj.includes(termoNumerico);

            return !!(encontrouNome || encontrouId || encontrouCnpj);
        },
        formatPercent(value) {
            return value != null ? `${(value * 100).toFixed(2)}%` : "-";
        },
        withTooltipColumn(title, renderFn) {
            return (value, record, index) => {
                const text = renderFn
                    ? renderFn(value, record, index)
                    : value ?? "-";

                return (
                    <a-tooltip title={title ?? ""}>
                        <span>{text}</span>
                    </a-tooltip>
                );
            };
        },
        renderMercadologico(value, row) {
            const curve = row[this.selectedCurve];
            const perc = this.getCurvePercFields(row, this.selectedCurve);

            const mercadologicoCompleto = value
                ? value.replace(/\s*>\s*/g, " - ")
                : null;

            return (
                <a-tooltip
                    placement="top"
                    title={
                        <div>
                            {mercadologicoCompleto && (
                                <div>
                                    <b>Mercadológico:</b>{" "}
                                    {mercadologicoCompleto}
                                </div>
                            )}
                            <div>
                                <b>{perc?.label}</b>
                            </div>
                            <div>Atual: {this.formatPercent(perc?.atual)}</div>
                            <div>
                                Acumulado: {this.formatPercent(perc?.acum)}
                            </div>

                            <div>
                                <b>Mercadológico</b>
                            </div>
                            <div>
                                Atual: {this.formatPercent(perc?.atualMerc)}
                            </div>
                            <div>
                                Acumulado: {this.formatPercent(perc?.acumMerc)}
                            </div>
                        </div>
                    }
                >
                    <div class="curve-inline">
                        <span
                            class={[
                                "curve-tag",
                                `curve-${String(curve).toLowerCase()}`,
                            ]}
                        >
                            {curve}
                        </span>

                        <span class="curve-text">
                            {value ? value.split(">").pop().trim() : "-"}
                        </span>
                    </div>
                </a-tooltip>
            );
        },
        getCurvePercFields(row, curveKey) {
            const curveFieldsMap = {
                curva_abc_faturamento_mercadologico: {
                    base: "faturamento",
                    label: "Faturamento",
                },
                curva_abcd_faturamento_mercadologico: {
                    base: "faturamento",
                    label: "Faturamento",
                },
                curva_abc_quantidade_mercadologico: {
                    base: "quantidade",
                    label: "Quantidade",
                },
                curva_abcd_quantidade_mercadologico: {
                    base: "quantidade",
                    label: "Quantidade",
                },
            };

            const curveInfo = curveFieldsMap[curveKey];

            if (!curveInfo) {
                return null;
            }

            return {
                label: curveInfo.label,
                atual: row[`perc_${curveInfo.base}`],
                acum: row[`perc_${curveInfo.base}_acum`],
                atualMerc: row[`perc_${curveInfo.base}_mercadologico`],
                acumMerc: row[`perc_${curveInfo.base}_mercadologico_acum`],
            };
        },
        async export_excel() {
            const result = await this.$swal.fire({
                title: "Exportar Excel?",
                text: "Será gerado um arquivo Excel com as colunas selecionadas e os filtros aplicados.",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Exportar",
                cancelButtonText: "Cancelar",
                reverseButtons: true,
            });

            if (!result.isConfirmed) {
                return;
            }

            this.$swal.fire({
                title: "Gerando arquivo...",
                text: "Aguarde alguns instantes.",
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    this.$swal.showLoading();
                },
            });

            this.exportingExcel = true;

            const columns = this.computedColumns
                .filter((col) => col.exportable !== false)
                .flatMap((col) => {
                    if (col.children) {
                        return col.children
                            .filter((child) => child.exportable !== false)
                            .map((child) => child.dataIndex);
                    }

                    return col.dataIndex;
                });

            try {
                const cli_id = this.client_id;
                const params = {
                    ...this.buildParams(this.pagination.total, 0),
                    export: "excel",
                    columns: JSON.stringify(columns),
                };
                Object.assign(params, this.buildAlgorithmFiltersParams());

                if (this.sorters.length) {
                    params.sort = JSON.stringify(this.sorters);
                }
                const { data } = await axios.get(
                    `${
                        process.env.VUE_APP_MIRAI_BASE_URL ||
                        "https://api-integration.clubdacotacao.com.br/v3/intelligence"
                    }/diagnostics/${
                        process.env.VUE_APP_MIRAI_CLI_ID || cli_id
                    }`,
                    {
                        params,
                        responseType: "blob",
                    }
                );

                const blob = new Blob([data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });

                const url = URL.createObjectURL(blob);

                const a = document.createElement("a");
                a.href = url;

                a.download = `diagnostics-${new Date()
                    .toISOString()
                    .slice(0, 10)}.xlsx`;

                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                URL.revokeObjectURL(url);

                await this.$swal.fire({
                    title: "Concluído!",
                    text: "Exportação concluída com sucesso.",
                    icon: "success",
                    confirmButtonText: "OK",
                });
            } catch (err) {
                console.error(err);

                await this.$swal.fire({
                    title: "Erro",
                    text: "Não foi possível exportar o arquivo.",
                    icon: "error",
                    confirmButtonText: "OK",
                });
            } finally {
                this.exportingExcel = false;
                this.$swal.close();
            }
        },
        handleKeydown(event) {
            if (
                event.key !== "Enter" &&
                event.key !== "ArrowDown" &&
                event.key !== "ArrowUp"
            ) {
                return;
            }
            event.preventDefault();

            const inputs = Array.from(
                document.querySelectorAll("input.ant-input")
            ).filter((el) => el.dataset.field === "qtd");

            const currentIndex = inputs.indexOf(event.target);
            if (currentIndex === -1) {
                return;
            }

            let nextIndex = currentIndex;
            if (event.key === "Enter" || event.key === "ArrowDown") {
                nextIndex = Math.min(currentIndex + 1, inputs.length - 1);
            }

            if (event.key === "ArrowUp") {
                nextIndex = Math.max(currentIndex - 1, 0);
            }

            const nextInput = inputs[nextIndex];
            if (nextInput) {
                nextInput.focus();
                nextInput.select();
            }
        },
        async handleTotalizadores() {
            this.showTotalizadores = !this.showTotalizadores;
        },
        removeSelectedProduct(item) {
            const key = this.getRowKey(item);

            this.$delete(this.selectedMap, key);

            this.selectedRowKeys = Object.keys(this.selectedMap);

            const storeId = String(item.id_loja);

            if (this.purchaseItems[storeId]) {
                this.purchaseItems[storeId] = this.purchaseItems[
                    storeId
                ].filter((product) => this.getRowKey(product) !== key);

                if (!this.purchaseItems[storeId].length) {
                    this.$delete(this.purchaseItems, storeId);

                    this.expandedRowKeys = this.expandedRowKeys.filter(
                        (id) => id !== storeId
                    );
                }
            }
            if (this.purchaseStores.length < 1)
                this.purchaseModalVisible = false;
        },
        mapMercadologicoTree(nodes, labels, parentLabel = "") {
            return nodes.map((node) => {
                const item = { title: node.title, value: node.value };
                const label = parentLabel
                    ? `${parentLabel} > ${node.title}`
                    : node.title;

                if (node.id !== undefined && node.id !== null) {
                    item.value = String(node.id);
                }
                labels[item.value] = label;

                if (node.children) {
                    item.children = this.mapMercadologicoTree(
                        node.children,
                        labels,
                        label
                    );
                }

                return item;
            });
        },
        mercadologicoAppliedLabels(values) {
            const tree = this.apiFilters.mercadologico || [];
            const compacted = tree.length
                ? this.compactMercadologicoIds(tree, new Set(values)).ids
                : values;

            return compacted.map(
                (value) => this.mercadologicoLabels[value] || value
            );
        },
        filterTooltipLines(key, value) {
            if (key !== "mercadologico__in") {
                return [this.formatFilterValue(key, value)];
            }

            const limit = 10;
            const labels = this.mercadologicoAppliedLabels(value);
            const lines = labels.slice(0, limit);

            if (labels.length > limit) {
                lines.push(`e mais ${labels.length - limit}`);
            }

            return lines;
        },
        compactMercadologicoIds(nodes, selected) {
            const ids = [];
            let all = true;

            nodes.forEach((node) => {
                if (node.children) {
                    const child = this.compactMercadologicoIds(
                        node.children,
                        selected
                    );

                    if (child.all) {
                        ids.push(node.value);
                    } else {
                        ids.push(...child.ids);
                        all = false;
                    }
                } else if (selected.has(node.value)) {
                    ids.push(node.value);
                } else {
                    all = false;
                }
            });

            return { ids, all };
        },
        buildInParam(values) {
            return values
                .map((value) => `'${String(value).replace(/'/g, "''")}'`)
                .join(",");
        },
        buildParams(limit = null, offset = null) {
            const params = {};

            if (limit !== null) {
                params.limit = limit;
            }

            if (offset !== null) {
                params.offset = offset;
            }

            Object.entries(this.filters).forEach(([field, value]) => {
                if (
                    value === undefined ||
                    value === null ||
                    value === "" ||
                    (Array.isArray(value) && !value.length)
                ) {
                    return;
                }

                // SEARCH
                if (field === "search") {
                    if (this.selectedSearch) {
                        if (this.selectedSearch === "id_produto") {
                            params[this.selectedSearch.toLowerCase()] = value;
                        } else {
                            params[
                                `${this.selectedSearch.toLowerCase()}__icontains`
                            ] = value;
                        }
                    } else {
                        params.search = value;
                    }

                    return;
                }

                // CURVAS
                if (field === "curvas") {
                    params[`${this.selectedCurve}__in`] = this.buildInParam(value);

                    return;
                }

                // STATUS
                if (field === "criticidade_reposicao__in") {
                    params.criticidade_reposicao__in = this.buildInParam(value);

                    return;
                }

                // MERCADOLÓGICO (ids da árvore do mirai)
                if (
                    field === "mercadologico__in" &&
                    this.usesMercadologicoIds
                ) {
                    params.mercadologico_id__in = this.compactMercadologicoIds(
                        this.apiFilters.mercadologico,
                        new Set(value)
                    ).ids.join(",");

                    return;
                }

                // MULTISELECT (__in)
                if (field.includes("__in")) {
                    params[field] = this.buildInParam(value);

                    return;
                }

                // DATE RANGE
                if (field === "ultima_data_emissao") {
                    const [start, end] = value;

                    if (start) {
                        params.ultima_data_emissao__gte =
                            this.$moment(start).format("YYYY-MM-DD");
                    }

                    if (end) {
                        params.ultima_data_emissao__lte =
                            this.$moment(end).format("YYYY-MM-DD");
                    }

                    return;
                }

                // RANGE SLIDER
                if (field === "cobertura_estoque_dias_range") {
                    params.cobertura_estoque_dias__gte =
                        value[0] != this.apiFilters.cobertura_range.min
                            ? value[0]
                            : undefined;
                    params.cobertura_estoque_dias__lte =
                        value[1] != this.apiFilters.cobertura_range.max
                            ? value[1]
                            : undefined;

                    return;
                }
                // RANGE SLIDER
                if (field === "estoque_range") {
                    params.estoque__gte =
                        value[0] != this.apiFilters.estoque_range.min
                            ? value[0]
                            : undefined;
                    params.estoque__lte =
                        value[1] != this.apiFilters.estoque_range.max
                            ? value[1]
                            : undefined;

                    return;
                }
                // RANGE SLIDER
                if (field === "dias_ultima_venda_range") {
                    params.dias_ultima_venda__gte =
                        value[0] != this.apiFilters.dias_ultima_venda_range.min
                            ? value[0]
                            : undefined;
                    params.dias_ultima_venda__lte =
                        value[1] != this.apiFilters.dias_ultima_venda_range.max
                            ? value[1]
                            : undefined;

                    return;
                }
                if (field === "sugestao_range") {
                    params.compra_sugestao_ajustado__gte =
                        value[0] != this.apiFilters.sugestao_range.min
                            ? value[0]
                            : undefined;
                    params.compra_sugestao_ajustado__lte =
                        value[1] != this.apiFilters.sugestao_range.max
                            ? value[1]
                            : undefined;

                    return;
                }

                // DEFAULT
                params[field] = value;
            });

            // SORTING
            if (this.sorters.length) {
                params.sort = JSON.stringify(this.sorters);
            }
            if (
                this.algorithmFilters.exibicao != "todos" &&
                !params.compra_sugestao_ajustado__gte
            ) {
                params.compra_sugestao_ajustado__gte = 1;
            }
            return params;
        },
        async deselectAllFiltered() {
            this.loading = true;

            this.$swal({
                title: "Removendo produtos",
                text: "Aguarde enquanto a seleção é atualizada...",
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    this.$swal.showLoading();
                },
            });
            try {
                const params = this.buildParams(this.pagination.total, 0);
                Object.assign(params, this.buildAlgorithmFiltersParams());
                let cli_id = this.client_id;

                const { data } = await axios.get(
                    `${
                        process.env.VUE_APP_MIRAI_BASE_URL ||
                        "https://api-integration.clubdacotacao.com.br/v3/intelligence"
                    }/diagnostics/${
                        process.env.VUE_APP_MIRAI_CLI_ID || cli_id
                    }`,
                    { params }
                );

                const records = Array.isArray(data.records) ? data.records : [];

                records.forEach((row) => {
                    const key = this.getRowKey(row);

                    this.$delete(this.selectedMap, key);
                });

                this.selectedRowKeys = Object.keys(this.selectedMap);

                this.$swal({
                    icon: "success",
                    title: "Remoção concluída",
                    text: `${records.length} produtos removidos da seleção`,
                });
            } catch (err) {
                console.error(err);

                this.$swal({
                    icon: "error",
                    title: "Erro",
                    text: "Não foi possível remover os registros.",
                });
            } finally {
                this.loading = false;
            }
        },
        async selectAllFiltered() {
            this.loading = true;

            this.$swal({
                title: "Selecionando produtos",
                text: "Buscando todos os itens do filtro...",
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    this.$swal.showLoading();
                },
            });

            try {
                const params = this.buildParams(this.pagination.total, 0);
                if (this.sorters.length) {
                    params.sort = JSON.stringify(this.sorters);
                }
                Object.assign(params, this.buildAlgorithmFiltersParams());
                let cli_id = this.client_id;
                const { data } = await axios.get(
                    `${
                        process.env.VUE_APP_MIRAI_BASE_URL ||
                        "https://api-integration.clubdacotacao.com.br/v3/intelligence"
                    }/diagnostics/${
                        process.env.VUE_APP_MIRAI_CLI_ID || cli_id
                    }`,
                    { params }
                );

                const records = Array.isArray(data.records) ? data.records : [];

                records.forEach((row) => {
                    const key = this.getRowKey(row);

                    this.$set(this.selectedMap, key, row);
                });

                this.selectedRowKeys = Object.keys(this.selectedMap);

                this.$swal({
                    icon: "success",
                    title: "Seleção concluída",
                    text: `${records.length} produtos adicionados à seleção`,
                });
            } catch (err) {
                console.error(err);

                this.$swal({
                    icon: "error",
                    title: "Erro",
                    text: "Não foi possível selecionar todos os registros filtrados.",
                });
            } finally {
                this.loading = false;
            }
        },
        visible_products() {
            const resp = [];

            this.products.forEach((product) => {
                if (
                    product.produto_descricao
                        .toUpperCase()
                        .includes(
                            this.current_product.produto_descricao.toUpperCase()
                        ) &&
                    true
                ) {
                    let converted_product = {
                        produtoDescricao: product.produto_descricao,
                        pro_codInterno: product.id_produto,
                        quantidade: product.estoque,
                        quantidade_sugestao: product.compra_sugestao_ajustado,
                    };
                    resp.push(converted_product);
                }
            });
            if (this.positiveOnly)
                return resp.filter((product) => this.getDiff(product) > 0);
            return resp;
        },
        openHistoryModal(product) {
            const hasIdentifier = product.id_produto;

            if (!hasIdentifier) {
                this.$swal.fire({
                    icon: "warning",
                    title: "Histórico não disponível",
                    text: "Este produto não possui histórico de compras e vendas disponível.",
                });
                return;
            }
            this.selectedLoja = product.id_loja;
            this.current_product = product;
            this.is_history_modal_open = true;
        },
        clearSelection() {
            this.selectedRowKeys = [];
            this.selectedMap = {};
            this.purchaseItems = {};
            this.expandedRowKeys = [];
        },
        handleTipoFornecedor(value) {
            delete this.filters.fornecedores_diferentes__lte;
            delete this.filters.fornecedores_diferentes__gte;
            delete this.filters.fornecedores_diferentes;

            if (value === "direta") {
                this.filters.fornecedores_diferentes__lte = 1;
            }
            if (value === "potencial") {
                this.filters.fornecedores_diferentes = 2;
            }
            if (value === "cotacao") {
                this.filters.fornecedores_diferentes__gte = 3;
            }
        },
        filterSelectOption(input, option) {
            return option.componentOptions.children[0].text
                .toLowerCase()
                .includes(input.toLowerCase());
        },
        getRowKey(row) {
            return `${row.id_produto}_${row.id_loja}`;
        },
        formatCNPJ(cnpj) {
            if (!cnpj) return "";
            cnpj = String(cnpj).padStart(14, "0");
            return cnpj
                .replace(/^(\d{2})(\d)/, "$1.$2")
                .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
                .replace(/\.(\d{3})(\d)/, ".$1/$2")
                .replace(/(\d{4})(\d)/, "$1-$2")
                .substring(0, 18);
        },
        openPurchaseModal() {
            this.purchaseModalVisible = true;

            const grouped = {};

            Object.values(this.selectedMap).forEach((item) => {
                const storeId = String(item.id_loja);

                if (!grouped[storeId]) {
                    grouped[storeId] = [];
                }

                grouped[storeId].push({
                    ...item,
                    request_quantity: Number(
                        item.compra_sugestao_ajustado || 0
                    ),
                });
            });

            this.purchaseItems = grouped;
            this.expandedRowKeys = Object.keys(grouped).length
                ? [Object.keys(grouped)[0]]
                : [];
        },
        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            if (sorter && sorter.order) {
                this.sorters = [
                    [sorter.field, sorter.order === "ascend" ? "asc" : "desc"],
                ];
            } else {
                this.sorters = [];
            }
            this.getListaProdutos(pagination.current);
        },
        reconstruirFiltrosRapidos() {
            this.filters.criticidade_reposicao__in = [];
            this.filters.estoque__lte = undefined;
            this.filters.cobertura_estoque_dias__lte = undefined;
            this.filters.curvas = undefined;

            let usarCurvaABC = false;

            this.filtrosRapidosSelecionados.forEach((type) => {
                switch (type) {
                    case "ruptura":
                        this.filters.criticidade_reposicao__in.push("RUPTURA");
                        break;

                    case "auditar":
                        this.filters.estoque__lte = 0;
                        break;

                    case "risco":
                        this.filters.criticidade_reposicao__in.push("CRITICO");
                        this.filters.cobertura_estoque_dias__lte = 7;
                        break;

                    case "ponto_pedido":
                        this.filters.criticidade_reposicao__in.push("BAIXO");
                        break;

                    case "curva_a":
                        this.filters.curvas = ["A"];
                        usarCurvaABC = true;
                        break;

                    case "curva_a_critico":
                        this.filters.criticidade_reposicao__in.push("CRITICO");
                        this.filters.curvas = ["A"];
                        usarCurvaABC = true;
                        break;

                    case "comprar_hoje":
                        this.filters.criticidade_reposicao__in.push(
                            "CRITICO",
                            "BAIXO"
                        );
                        this.filters.sugestao_range = [
                            1,
                            this.apiFilters.sugestao_range.max ?? null,
                        ];
                        break;

                    case "excesso":
                        this.filters.criticidade_reposicao__in.push("EXCESSO");
                        break;

                    case "sem_venda":
                        this.filters.criticidade_reposicao__in.push(
                            "SEM_VENDA",
                            "OBSOLETO"
                        );
                        break;
                }
            });

            if (usarCurvaABC) {
                this.selectedCurve = "curva_abc_quantidade_mercadologico";
            }

            if (!this.filters.criticidade_reposicao__in.length) {
                this.filters.criticidade_reposicao__in = undefined;
            } else {
                // remove duplicados
                this.filters.criticidade_reposicao__in = [
                    ...new Set(this.filters.criticidade_reposicao__in),
                ];
            }
        },

        async aplicarFiltroRapido(type) {
            const index = this.filtrosRapidosSelecionados.indexOf(type);

            if (index >= 0) {
                this.filtrosRapidosSelecionados.splice(index, 1);
            } else {
                this.filtrosRapidosSelecionados.push(type);
            }

            this.reconstruirFiltrosRapidos();

            await this.getListaProdutos();
        },
        limparFiltroRapido() {
            this.filtroSelecionado = undefined;
            this.filters.criticidade_reposicao = undefined;
            this.filters.cobertura_estoque_dias = undefined;
            this.filters.compra_sugestao_ajustado = undefined;
            this.filters.criticidade_reposicao__in = undefined;
            this.filters.estoque__lte = undefined;
        },
        handleResize() {
            let wasDesktop = this.isDesktop;
            this.isDesktop = window.innerWidth >= 720;
            if (wasDesktop != this.isDesktop) this.buildTable();
            this.$nextTick(() => {
                setTimeout(() => {
                    const tableBody = this.$el.querySelector(".ant-table-body");
                    if (tableBody) {
                        tableBody.scrollLeft = 0;
                    }
                }, 100);
            });
        },
        resetFilters() {
            this.algorithmFilters = {
                ...defaultAlgorithmFilters,
            };
        },
        buildAlgorithmFiltersParams() {
            const f = this.algorithmFilters;
            if (f == defaultAlgorithmFilters) return;
            return {
                algoritmo: {
                    estoque: f.estoque,
                    pendencia: f.pendencia,
                    cobertura: f.cobertura,
                    giro: f.giro,
                    unidade: f.unidade,
                    cobertura_dias:
                        f.cobertura === "cobertura_fixa"
                            ? f.cobertura_dias
                            : undefined,
                    exibicao: f.exibicao,
                },
            };
        },
        async getListaProdutos(pageNumber, showDataStatusAlert = true) {
            const page = typeof pageNumber === "number" ? pageNumber : 1;
            this.loading = true;
            this.visible = false;
            const requestId = Date.now();
            this.lastRequestId = requestId;

            try {
                const params = this.buildParams(
                    this.pagination.pageSize,
                    (page - 1) * this.pagination.pageSize
                );

                if (this.sorters.length) {
                    params.sort = JSON.stringify(this.sorters);
                }
                Object.assign(params, this.buildAlgorithmFiltersParams());
                let cli_id = this.client_id;
                const { data } = await axios.get(
                    `${
                        process.env.VUE_APP_MIRAI_BASE_URL ||
                        "https://api-integration.clubdacotacao.com.br/v3/intelligence"
                    }/diagnostics/${
                        process.env.VUE_APP_MIRAI_CLI_ID || cli_id
                    }`,
                    {
                        params,
                    }
                );
                if (this.lastRequestId !== requestId) return;
                this.dataStatus = data?.data_status || null;
                if (showDataStatusAlert && !this.dataStatusAlertShown && this.dataStatus?.message) {
                    this.dataStatusAlertShown = true;
                    this.openDataStatusAlertModal("Alertas na base");
                }
                this.kpis = data.kpis;
                const records = Array.isArray(data.records) ? data.records : [];
                this.products = records;
                this.pagination.total = data.meta.total;
                this.pagination.current = page;
                this.page = page;
            } catch (err) {
                console.error(err);
            } finally {
                this.appliedFilters = {
                    ...this.filters,
                };
                if (this.lastRequestId === requestId) {
                    this.loading = false;
                }
            }
        },
        async syncListaProdutos(pageNumber) {
            this.syncing = true;

            const page = typeof pageNumber === "number" ? pageNumber : 1;

            this.visible = false;

            const requestId = Date.now();
            this.lastRequestId = requestId;

            try {
                const cli_id = this.client_id;

                const { data } = await axios.get(
                    `${
                        process.env.VUE_APP_MIRAI_BASE_URL ||
                        "https://api-integration.clubdacotacao.com.br/v3/intelligence"
                    }/diagnostics/${
                        process.env.VUE_APP_MIRAI_CLI_ID || cli_id
                    }` + "/sync"
                );
                this.dataStatus = data?.data_status || null;
                if (this.dataStatus?.message) {
                    this.dataStatusAlertShown = true;
                    this.openDataStatusAlertModal("Sincronização com alertas");
                } else
                    this.$swal({
                        icon: "success",
                        title: "Sincronização concluída",
                        text: "A sincronização foi concluída com sucesso.",
                        confirmButtonText: "OK",
                    });
            } catch (err) {
                console.error(err);

                this.$swal({
                    icon: "error",
                    title: "Erro ao sincronizar",
                    text:
                        err?.response?.data?.message ||
                        "Não foi possível concluir a sincronização.",
                    confirmButtonText: "OK",
                });
            } finally {
                await this.getfilters();
                this.syncing = false;
                this.getListaProdutos(page, false);
            }
        },
        async openDataStatusAlertModal(title) {
            const result = await this.$swal({
                icon: "warning",
                title,
                text: this.dataStatus.message,
                confirmButtonText: "OK",
                showDenyButton: true,
                denyButtonText: "Falar com o suporte",
                denyButtonColor: "#6c757d",
            });
            if (result.isDenied) this.$root.$emit("open-support-chat");
        },
        async getfilters() {
            try {
                let cli_id = localStorage.getItem("cli_id");
                const { data } = await axios.get(
                    `${
                        process.env.VUE_APP_MIRAI_BASE_URL ||
                        "https://api-integration.clubdacotacao.com.br/v3/intelligence"
                    }/diagnostics/${
                        process.env.VUE_APP_MIRAI_CLI_ID || cli_id
                    }` + "/filters"
                );
                const rangeKeys = [
                    "cobertura_estoque_dias_range",
                    "estoque_range",
                    "dias_ultima_venda_range",
                    "sugestao_range",
                ];
                const customizedRanges = rangeKeys.filter((key) =>
                    this.isFilterActive(key, this.filters[key])
                );
                const previousLabels = this.mercadologicoLabels;
                const mercadologicoLabels = {};
                const mercadologico = data.filters.mercadologico || [];

                this.apiFilters = {
                    ...data.filters,
                    mercadologico: this.mapMercadologicoTree(
                        mercadologico,
                        mercadologicoLabels
                    ),
                };
                this.mercadologicoLabels = mercadologicoLabels;
                this.usesMercadologicoIds = mercadologico.some(
                    (node) => node.id !== undefined && node.id !== null
                );

                const valueByLabel = Object.fromEntries(
                    Object.entries(mercadologicoLabels).map(
                        ([value, label]) => [label, value]
                    )
                );
                this.filters.mercadologico__in = (
                    this.filters.mercadologico__in || []
                )
                    .map((value) => valueByLabel[previousLabels[value]])
                    .filter((value) => value !== undefined);

                rangeKeys
                    .filter((key) => !customizedRanges.includes(key))
                    .forEach((key) => {
                        this.filters[key] = this.getDefaultFilterValue(key);
                    });
            } catch (err) {
                console.error(err);
            }
        },
        limparFiltros() {
            this.resetFilterState();
            this.markSavedFilterActive(null);
            this.getListaProdutos();
        },
        resetFilterState() {
            this.filtrosRapidosSelecionados = [];
            this.filters = {
                ean: undefined,
                produto_descricao: undefined,
                curva_abcd_faturamento_mercadologico: undefined,
                curva_abcd_quantidade_mercadologico: undefined,
                mercadologico: undefined,
                mercadologico__in: [],
                grupo: undefined,
                estoque: undefined,
                giro_medio: undefined,
                cobertura_estoque_dias: undefined,
                ultima_data_emissao: undefined,
                compra_sugestao_ajustado: undefined,
                criticidade_reposicao: undefined,
                search: undefined,
                cobertura_estoque_dias_range: this.getDefaultFilterValue(
                    "cobertura_estoque_dias_range"
                ),
                estoque_range: this.getDefaultFilterValue("estoque_range"),
                curvas: undefined,
                estoque__lte: undefined,
                criticidade_reposicao__in: [],
                dias_ultima_venda_range: this.getDefaultFilterValue(
                    "dias_ultima_venda_range"
                ),
                sugestao_range: this.getDefaultFilterValue("sugestao_range"),
                tipo_produto__in: undefined,
            };
            this.tipoFornecedor = undefined;
            this.sorters = [];
        },
        savedFilterPayload() {
            return serializeDiagnosisState({
                filters: this.filters,
                isActive: (key, value) => this.isFilterActive(key, value),
                rangeDefault: (key) => this.getDefaultFilterValue(key),
                selectedSearch: this.selectedSearch,
                selectedCurve: this.selectedCurve,
                tipoFornecedor: this.tipoFornecedor,
                filtrosRapidos: this.filtrosRapidosSelecionados,
                sorters: this.sorters,
                mercadologicoLabels: this.mercadologicoLabels,
                columns: this.selectedColumns,
                columnPreset: this.selectedPreset,
            });
        },
        async applySavedFilter(savedFilter) {
            const payload = savedFilter?.payload || {};
            const columns = restoreDiagnosisColumns(
                payload,
                this.selectableColumns.map((col) => col.dataIndex)
            );

            this.resetFilterState();
            this.selectedSearch = payload.selectedSearch || undefined;

            if (payload.selectedCurve) {
                this.selectedCurve = payload.selectedCurve;
            }

            if (columns && this.columnPresets[payload.columnPreset]) {
                this.selectedPreset = payload.columnPreset;
            }

            // Os watchers de selectedSearch/selectedCurve limpam search/curvas e
            // o de selectedPreset troca as colunas pelas do preset.
            await this.$nextTick();

            if (columns) {
                this.selectedColumns = columns;
            }

            this.filters = {
                ...this.filters,
                ...restoreDiagnosisFilters(payload, {
                    mercadologicoLabels: this.mercadologicoLabels,
                    toDate: (value) => this.$moment(value),
                    rangeDefault: (key) => this.getDefaultFilterValue(key),
                }),
            };
            this.tipoFornecedor = payload.tipoFornecedor || undefined;
            this.filtrosRapidosSelecionados = [...(payload.filtrosRapidos || [])];
            this.sorters = payload.sorters || [];
            this.markSavedFilterActive(savedFilter?.id ?? null);
            this.savedFiltersModalVisible = false;
            this.getListaProdutos(1);
        },
        async openSavedFilters() {
            this.savedFiltersModalVisible = true;

            if (this.savedFiltersAvailable || this.savedFiltersLoading) {
                return;
            }

            await this.loadSavedFilters();

            if (!this.savedFiltersAvailable) {
                this.savedFiltersModalVisible = false;
                this.$message.error("Não foi possível carregar os filtros salvos.");
            }
        },
        markSavedFilterActive(id) {
            this.activeSavedFilterId = id;
            this.activeSavedFilterSnapshot =
                id === null ? null : JSON.stringify(this.savedFilterPayload());
        },
        async loadSavedFilters() {
            this.savedFiltersLoading = true;

            try {
                const { data } = await new SavedFiltersService().list(
                    "diagnosis"
                );
                this.savedFilters = data.data || [];
                this.savedFiltersAvailable = true;
            } catch (err) {
                console.error(err);
                this.savedFilters = [];
                this.savedFiltersAvailable = false;
            } finally {
                this.savedFiltersLoading = false;
            }

            return this.savedFilters;
        },
        showDrawer() {
            this.visible = true;
        },
        onClose() {
            this.visible = false;
        },
        //MODAL
        getQuantidadeAjustada(item) {
            const embalagem = Number(item.quantidade_embalagem || 0)
            const quantidade = Number(item.request_quantity || 0)

            return embalagem > 0
                ? quantidade * embalagem
                : quantidade
        },
        handleRequestQuantityInput(event, record) {
            let value = event.target.value.replace(/\D/g, "");

            value = value.replace(/^0+(?=\d)/, "");

            record.request_quantity = value

            const quantidadeAjustada = this.getQuantidadeAjustada(record)

            record.cobertura_prevista = Math.round(
                (quantidadeAjustada + (+record.estoque || 0)) /
                (+record.giro_medio_ponderado || 1)
            )
        },
        buildPurchasePayload() {
            return Object.entries(this.purchaseItems)

                .map(([storeId, items]) => {
                    const firstItem = items[0];

                    return {
                        // controle interno frontend
                        store_id: storeId,

                        due_date: moment().add(7, "days").format("YYYY-MM-DD"),

                        store: {
                            cnpj: firstItem.loja_cnpj.padStart(14, "0"),
                        },

                        update_products: 0,

                        name: this.request_name,

                        payment_term: "",

                        payment_term_id: null,

                        obs: this.obs
                            ? this.obs + " - Diagnóstico"
                            : "Diagnóstico",

                        origem_id: 6,

                        dispositivo_origem_id: 1,

                        is_public: true,

                        origem_id: 6,

                        items: items.map((item) => ({
                            ean: item.ean_principal || item.id_produto,

                            name: item.produto_descricao,

                            quantity: Number(item.request_quantity),

                            last_offer_price: Number(item.ultimo_custo || 0),

                            internal_code: item.id_produto,

                            stock: item.estoque,

                            packing:
                                item.quantidade_embalagem
                                    ? `${item.unidade || 'UN'} ${item.quantidade_embalagem}`
                                    : 'UN 1',

                            purchase_unit:
                                item.unidade || 'UN',

                            brands: [],
                        })),
                    };
                })

                .filter((store) => store.items.length);
        },
        async submitPurchaseRequest() {
            try {
                this.purchaseSubmitting = true;

                const payload = this.buildPurchasePayload();

                if (!payload.length) {
                    this.$swal({
                        icon: "warning",
                        title: "Nenhum item válido",
                        text: "Não há itens para criar a requisição.",
                    });

                    this.purchaseModalVisible = false;
                    return;
                }

                this.$swal({
                    title: "Criando requisições...",
                    text: "Aguarde enquanto as requisições são criadas.",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    },
                });

                const pendingStores = [...payload];

                while (pendingStores.length) {
                    const currentStore = pendingStores[0];

                    try {
                        await this.service.createDiagnosisRequest(currentStore);

                        pendingStores.shift();

                        this.$delete(
                            this.purchaseItems,
                            String(currentStore.store_id)
                        );

                        this.selectedRowKeys = this.selectedRowKeys.filter(
                            (key) =>
                                !currentStore.items.some(
                                    (item) => this.getRowKey(item) === key
                                )
                        );

                        this.expandedRowKeys = this.expandedRowKeys.filter(
                            (key) =>
                                String(key) !== String(currentStore.store_id)
                        );
                    } catch (storeError) {
                        console.error(
                            "Erro na loja:",
                            currentStore.store_id,
                            storeError
                        );

                        this.$swal({
                            icon: "error",
                            title: "Erro ao criar requisição",
                            text: `Não foi possível criar a requisição da loja ${currentStore.store_id}.`,
                        });

                        return;
                    }
                }

                this.purchaseModalVisible = false;
                this.selectedRowKeys = [];
                this.selectedMap = {};
                this.purchaseItems = {};

                this.$swal({
                    icon: "success",
                    title: "Sucesso!",
                    text: "As requisições foram criadas com sucesso.",
                    confirmButtonText: "OK",
                });
            } catch (error) {
                console.error(error);

                this.$swal({
                    icon: "error",
                    title: "Erro",
                    text: "Ocorreu um erro ao criar as requisições.",
                });
            } finally {
                this.purchaseSubmitting = false;
            }
        },
        getStatusColor(status) {
            const colors = {
                success: "#52c41a", // verde
                warning: "#faad14", // amarelo
                danger: "#cf1322", // vermelho
            };

            return colors[status] || "#d9d9d9";
        },
    },
    mounted() {
        this.getfilters();
        this.cancelSource = axios.CancelToken.source();
        this.getListaProdutos(1);
        this.loadSavedFilters();
        this.$store.dispatch("user/reload_user");
        this.$store.dispatch("set_breadcrumbs", this.breadcrumbs);
        const savedColumns = sessionStorage.getItem(
            "diagnosis_selected_columns"
        );

        const savedPreset = sessionStorage.getItem("diagnosis_selected_preset");

        if (savedColumns) {
            try {
                this.selectedColumns = JSON.parse(savedColumns);
            } catch (err) {
                console.error(err);
            }
        }

        if (savedPreset) {
            this.selectedPreset = savedPreset;
        }

        if (!this.selectedColumns || !this.selectedColumns.length) {
            this.selectedPreset = this.selectedPreset || "basico";

            if (this.selectedPreset === "completo") {
                this.selectedColumns = this.allColumns.map(
                    (col) => col.dataIndex
                );
            } else {
                this.selectedColumns = [
                    ...(this.columnPresets[this.selectedPreset] || []),
                ];
            }
        }
    },
    computed: {
        fornecedoresOptions() {
            const porCnpj = new Map();

            (this.apiFilters.fornecedores || []).forEach((fornecedor) => {
                if (!fornecedor?.cnpj) return;

                if (!porCnpj.has(fornecedor.cnpj)) {
                    porCnpj.set(fornecedor.cnpj, {
                        cnpj: fornecedor.cnpj,
                        ids: [],
                        nomes: [],
                    });
                }

                const item = porCnpj.get(fornecedor.cnpj);
                const id = fornecedor.id_fornecedor;
                const nome = fornecedor.nomefantasia;

                if (id != null && !item.ids.includes(id)) item.ids.push(id);
                if (nome && !item.nomes.includes(nome)) item.nomes.push(nome);
            });

            return Array.from(porCnpj.values());
        },
        appliedFiltersCount() {
            const filters = Object.entries(this.appliedFilters).filter(
                ([key, value]) => this.isFilterActive(key, value)
            ).length;

            const algorithms = Object.entries(this.algorithmFilters).filter(
                ([key, value]) => this.isAlgorithmActive(key, value)
            ).length;

            return filters + algorithms;
        },
        hasAppliedFilters() {
            return (
                Object.entries(this.appliedFilters).some(([key, value]) =>
                    this.isFilterActive(key, value)
                ) ||
                Object.entries(this.algorithmFilters).some(([key, value]) =>
                    this.isAlgorithmActive(key, value)
                )
            );
        },
        client_id() {
            return localStorage.getItem("cli_id");
        },
        savedFilterRangeFields() {
            return [
                ["cobertura_estoque_dias_range", "Cobertura (dias)"],
                ["estoque_range", "Estoque"],
                ["dias_ultima_venda_range", "Dias desde a última venda"],
                ["sugestao_range", "Sugestão"],
            ].map(([key, label]) => ({
                key,
                label,
                base: this.getDefaultFilterValue(key),
            }));
        },
        activeSavedFilterModified() {
            return (
                this.activeSavedFilterId !== null &&
                JSON.stringify(this.savedFilterPayload()) !==
                    this.activeSavedFilterSnapshot
            );
        },
        percentual_curva_a() {
            return (
                ((this.kpis?.sku_curva_a_critico || 0) /
                    (this.kpis?.sku_curva_a || 1)) *
                100
            ).toFixed(1);
        },
        totalItems() {
            return this.purchaseStores.reduce(
                (acc, store) => acc + store.totalItems,
                0
            );
        },
        totalUnits() {
            return this.purchaseStores.reduce(
                (acc, store) =>
                    acc +
                    store.items.reduce(
                        (t, item) =>
                            t +
                            this.getQuantidadeAjustada(item),
                        0
                    ),
                0
            );
        },
        totalEstimated() {
            return this.purchaseStores.reduce(
                (acc, store) => acc + store.totalValue,
                0
            );
        },
        purchaseStores() {
            return Object.entries(
                this.purchaseItems
            ).map(([storeId, items]) => ({
                storeId,                
                items,
                cnpj: items[0]?.loja_cnpj,
                storeName: items[0]?.loja_descricao,
                totalItems: items.length,
                totalValue: items.reduce((total, item) => {
                    return total +
                        (this.getQuantidadeAjustada(item) *
                        Number(item.ultimo_custo || 0))
                    }, 0)
            }))
        },
        purchaseStoresMock() {
            const stores = Object.entries(this.purchaseItems || {}).map(
                ([storeId, items]) => ({
                    storeId,
                    items,

                    totalItems: items.length,

                    totalValue: items.reduce(
                        (total, item) =>
                            total +
                            Number(item.request_quantity || 0) *
                                Number(item.ultimo_custo || 0),
                        0
                    ),
                })
            );

            return Array(20)
                .fill(null)
                .flatMap((_, index) =>
                    stores.map((store) => ({
                        ...store,

                        storeId: `${store.storeId}-${index}`,
                    }))
                );
        },
        selectedProducts() {
            return this.selectedRowKeys
                .map((key) => this.selectedMap[key])
                .filter(Boolean);
        },

        selectedPurchaseValue() {
            return this.selectedProducts.reduce((total, item) => {
                return (
                    total +
                    Number(item.compra_sugestao_ajustado || 0) *
                        Number(item.ultimo_custo || 0)
                );
            }, 0);
        },
        curveOptions() {
            let options = ["A", "B", "C"];
            if (this.selectedCurve.includes("abcd")) options.push("D");
            return options;
        },
        selectableColumns() {
            return this.allColumns.filter((col) => !col.fixed);
        },
        screenWidth() {
            return window.innerWidth;
        },
        rowSelectionComputed() {
            return {
                selectedRowKeys: this.selectedRowKeys,

                onChange: (selectedRowKeys, selectedRows) => {
                    this.selectedRowKeys = selectedRowKeys;

                    selectedRows.forEach((row) => {
                        const key = this.getRowKey(row);

                        const previous = this.selectedMap[key];

                        this.$set(
                            this.selectedMap,
                            key,
                            previous
                                ? {
                                      ...row,
                                      compra_sugestao_ajustado:
                                          previous.compra_sugestao_ajustado,
                                  }
                                : row
                        );
                    });

                    Object.keys(this.selectedMap).forEach((key) => {
                        if (!selectedRowKeys.includes(key)) {
                            this.$delete(this.selectedMap, key);
                        }
                    });
                },

                onSelectAll: async (selected, selectedRows, changeRows) => {
                    if (this.pagination.total <= this.pagination.pageSize) {
                        return;
                    }

                    if (selected) {
                        const result = await this.$swal({
                            title: "Selecionar registros",
                            text: "Deseja selecionar apenas a página atual ou todos os registros filtrados?",
                            icon: "question",
                            showCancelButton: true,
                            confirmButtonText: "Todos",
                            cancelButtonText: "Página atual",
                        });

                        if (result.isConfirmed) {
                            this.selectAllFiltered();
                        }

                        return;
                    }

                    const result = await this.$swal({
                        title: "Remover registros",
                        text: "Deseja remover apenas a página atual ou todos os registros filtrados?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Todos",
                        cancelButtonText: "Página atual",
                    });

                    if (result.isConfirmed) {
                        this.deselectAllFiltered();
                    }
                },
            };
        },
        computedColumns() {
            const visible = this.selectedColumns || [];

            const leftFixed = this.allColumns.filter(
                (col) => col.fixed === "left"
            );

            const rightFixed = this.allColumns.filter(
                (col) => col.fixed === "right"
            );

            const fixedIndexes = new Set([
                ...leftFixed.map((col) => col.dataIndex || col.key),
                ...rightFixed.map((col) => col.dataIndex || col.key),
            ]);

            const normalColumns = visible
                .map((dataIndex) =>
                    this.allColumns.find(
                        (col) => (col.dataIndex || col.key) === dataIndex
                    )
                )
                .filter(Boolean)
                .filter((col) => !fixedIndexes.has(col.dataIndex || col.key));

            return [...leftFixed, ...normalColumns, ...rightFixed].map(
                (col) => ({
                    ...col,

                    sorter: col.sorter === false ? false : true,

                    sortOrder:
                        this.sorters[0]?.[0] === (col.dataIndex || col.key)
                            ? this.sorters[0][1] === "asc"
                                ? "ascend"
                                : "descend"
                            : null,
                })
            );
        },

        dashboardCards() {
            return [
                {
                    key: "ruptura",
                    title: "SKUS EM RUPTURA",
                    value: this.kpis.sku_ruptura || 0,
                    suffix: "itens",
                    footerBadge: "+18",
                    footerBadgeType: "danger",
                    footerText: "vs ontem",
                    borderColor: this.rupturaBorderColor,
                },
                {
                    key: "auditar",
                    title: "ESTOQUE A VERIFICAR",
                    value: this.kpis.sku_estoque_a_auditar || 0,
                    suffix: "SKUs",
                    footerBadge: "+5",
                    footerBadgeType: "danger",
                    footerText: "saldo zero ou negativo",
                    borderColor: this.estoqueAuditarBorderColor,
                },
                {
                    key: "risco",
                    title: "SKUS EM RISCO (≤7D)",
                    value: this.kpis.sku_em_risco || 0,
                    suffix: "itens",

                    valueColor: "#faad14",

                    footerBadge: "+2",
                    footerBadgeType: "danger",
                    footerText: "cobertura ≤ 7 dias",
                    borderColor: this.riscoBorderColor,
                },
                {
                    key: "ponto_pedido",
                    title: "ABAIXO DO PONTO DE PEDIDO",
                    value: this.kpis.sku_ponto_de_pedido || 0,
                    suffix: "SKUs",
                    footerBadge: "+34",
                    footerBadgeType: "danger",
                    footerText: "estoque < ponto de pedido",
                    borderColor: this.pontoPedidoBorderColor,
                },
                {
                    key: "curva_a_critico",
                    title: "CURVA A — CRÍTICOS",
                    value: this.kpis.sku_curva_a_critico || 0,
                    suffix: `/${this.kpis.sku_curva_a || 0}`,

                    valueColor: "#722ed1",

                    footerBadge: "+6",
                    footerBadgeType: "danger",
                    footerText: `${this.percentual_curva_a}% da curva A`,
                    borderColor: this.curvaACriticaBorderColor,
                },
                {
                    key: "comprar_hoje",
                    title: "SUGESTÕES AUTOMÁTICAS",
                    value: this.kpis.sku_comprar_hoje || 0,
                    suffix: "SKUs",

                    valueColor: "#1890ff",

                    footerBadge: "+10",
                    footerBadgeType: "danger",
                    footerText: "pedidos sugeridos hoje",
                    borderColor: this.comprarHojeBorderColor,
                },
                {
                    key: "excesso",
                    title: "EXCESSO DE ESTOQUE",
                    value: this.kpis.sku_em_excesso || 0,
                    suffix: "SKUs",

                    valueColor: "#13c2c2",

                    footerBadge: "+12",
                    footerBadgeType: "danger",
                    footerText: "cobertura > 60 dias",
                    borderColor: this.excessoBorderColor,
                },
                {
                    key: "sem_venda",
                    title: "SKUS SEM GIRO (60D)",
                    value: this.kpis.sku_sem_venda || 0,
                    suffix: "SKUs",

                    valueColor: "#8c8c8c",

                    footerBadge: "+9",
                    footerBadgeType: "danger",
                    footerText: "sem venda há 60+ dias",
                    borderColor: this.semGiroBorderColor,
                },
            ];
        },
        rupturaBorderColor() {
            const value = this.kpis.sku_ruptura || 0;

            if (value <= 5) return "#52c41a";
            if (value <= 15) return "#faad14";

            return "#cf1322";
        },

        estoqueAuditarBorderColor() {
            const value = this.kpis.sku_estoque_a_auditar || 0;

            if (value <= 10) return "#52c41a";
            if (value <= 30) return "#faad14";

            return "#cf1322";
        },

        riscoBorderColor() {
            const value = this.kpis.sku_em_risco || 0;

            if (value <= 10) return "#52c41a";
            if (value <= 25) return "#faad14";

            return "#cf1322";
        },

        pontoPedidoBorderColor() {
            const value = this.kpis.sku_ponto_de_pedido || 0;

            if (value <= 15) return "#52c41a";
            if (value <= 40) return "#faad14";

            return "#cf1322";
        },

        curvaACriticaBorderColor() {
            const total = this.kpis.sku_curva_a || 0;
            const criticos = this.kpis.sku_curva_a_critico || 0;

            if (!total) return "#52c41a";

            const percentual = (criticos / total) * 100;

            if (percentual <= 5) return "#52c41a";
            if (percentual <= 15) return "#faad14";

            return "#cf1322";
        },

        comprarHojeBorderColor() {
            const value = this.kpis.sku_comprar_hoje || 0;

            if (value <= 20) return "#52c41a";
            if (value <= 50) return "#faad14";

            return "#cf1322";
        },

        excessoBorderColor() {
            const value = this.kpis.sku_em_excesso || 0;

            if (value <= 10) return "#52c41a";
            if (value <= 30) return "#faad14";

            return "#cf1322";
        },

        semGiroBorderColor() {
            const value = this.kpis.sku_sem_venda || 0;

            if (value <= 10) return "#52c41a";
            if (value <= 25) return "#faad14";

            return "#cf1322";
        },
    },
    watch: {
        selectedSearch: function () {
            this.filters.search = undefined;
        },
        selectedCurve: function () {
            this.filters.curvas = undefined;
        },
        selectedColumns: {
            deep: true,
            handler(value) {
                sessionStorage.setItem(
                    "diagnosis_selected_columns",
                    JSON.stringify(value || [])
                );
            },
        },

        selectedPreset(value) {
            sessionStorage.setItem("diagnosis_selected_preset", value || "");

            if (value && value !== "completo" && this.columnPresets[value]) {
                this.selectedColumns = [...this.columnPresets[value]];
            }

            if (value === "completo") {
                this.selectedColumns = this.selectableColumns.map(
                    (col) => col.dataIndex
                );
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.applied-filters-count {
    color: #8c8c8c;
    font-size: 12px;
}

.toggle-applied-filters-action {
    color: #8c8c8c;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    user-select: none;
    transition: color 0.2s ease;
    margin-left: auto;
}

.toggle-applied-filters-action:hover {
    color: #1890ff;
}
.applied-filters-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 10px;
}
.applied-filters-container > ::v-deep .ant-card-body {
    padding: 10px !important;
    background-color: #f5f5f5;
}

.applied-filters {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    min-width: 0;
}

.filter-tag,
.algorithm-tag {
    max-width: 100%;
    margin-right: 0;

    ::v-deep .anticon-close {
        flex-shrink: 0;
    }
}

.toggle-applied-filters {
    margin-left: auto;

    display: flex;
    align-items: center;
    gap: 10px;

    white-space: nowrap;
    flex-shrink: 0;
}

.toggle-applied-filters:hover {
    color: #1890ff;
}

.filter-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;

    height: 30px;
    padding: 4px 10px;

    border-radius: 999px !important;
    border: 1px solid #bfbfbf;

    background: #fafafa;
    color: #595959;

    font-size: 13px;
    transition: all 0.2s ease;
}

.algorithm-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;

    height: 30px;
    padding: 4px 10px;

    border-radius: 999px !important;

    background: #fff7e6;
    border: 1px solid #ffd591;
    color: #d46b08;

    font-size: 13px;
    transition: all 0.2s ease;
}

.algorithm-tag:hover {
    background: #fff2d9;
    border-color: #ffb86b;
    color: #ad4e00;
}
.filter-tag:hover {
    background: #f5f5f5;
    border-color: #8c8c8c;
    color: #434343;
}

.filter-tag-icon {
    flex-shrink: 0;
    font-size: 12px;
    opacity: 0.75;
}

.filter-tag-label {
    flex-shrink: 0;
    font-weight: 600;
}

.filter-tag-value {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    opacity: 0.85;
}
.giro-tooltip-table {
    width: 100%;
    border-collapse: collapse;
}

.giro-tooltip-table th {
    font-size: 0.8rem;
    font-weight: 600;
    padding-bottom: 4px;
}

.giro-tooltip-table td {
    padding: 2px 0;
}

.giro-tooltip-table th:first-child,
.giro-tooltip-table td:first-child {
    text-align: left !important;
    color: #fff !important;
}

.giro-tooltip-table th:nth-child(2),
.giro-tooltip-table td:nth-child(2) {
    text-align: right !important;
    color: #fff !important;
}

.giro-tooltip-table th:nth-child(3),
.giro-tooltip-table td:nth-child(3) {
    text-align: right !important;
    color: #fff !important;
}

.giro-tooltip {
    min-width: 140px;
}

.giro-tooltip-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.8rem;
    margin-bottom: 6px;
}

.giro-tooltip-divider {
    height: 1px;
    background: rgba(255, 255, 255, 0.15);
    margin-bottom: 6px;
}

.giro-medio-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    cursor: help;
}
.suggestion-column {
    width: 16px;
    margin-left: 4px;
    display: inline-flex;
    justify-content: center;
}
.tooltip-nowrap {
    white-space: nowrap;
    max-width: none;
}
::v-deep .ant-table-expanded-row > td {
    padding-left: 0 !important;
    padding-bottom: 0 !important;
}
.fixed-height-select.ant-select,
.fixed-height-select .ant-select-selection--multiple {
    min-height: 32px !important;
    max-height: 32px !important;
    overflow: auto;
}
.ant-table-layout-fixed table {
    table-layout: auto;
}
.dropdown-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    cursor: pointer;
    font-size: 0.9em;
    color: #605f5f;
}
.actions-container {
    position: relative;
    display: flex;
    justify-content: center;
}
.product-id-cell {
    display: flex;
    align-items: center;
    gap: 6px;
}

.product-details-btn {
    padding: 0 !important;

    display: flex;
    align-items: center;
    justify-content: center;

    color: var(--primary-color);
}

.product-details-btn .material-icons-round {
    font-size: 0.9rem;
}
.item-button {
    vertical-align: bottom;
}
.purchase-footer {
    position: fixed;
    left: 50%;
    bottom: 14px;
    transform: translateX(-50%);
    z-index: 999;

    width: calc(100% - 32px);
    max-width: 70vw;

    background: #22252a;
    border-radius: 10px;

    padding: 8px 16px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;

    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.24), 0 2px 8px rgba(0, 0, 0, 0.16);
}

.purchase-footer-left {
    display: flex;
    align-items: center;
    gap: 16px;

    color: #ffffff;
}

.purchase-footer-info {
    font-size: 0.74rem;
    color: rgba(255, 255, 255, 0.68);
}

.purchase-footer-count {
    font-size: 0.9rem;
    font-weight: 700;
    color: #ffffff;
}

.purchase-footer-total {
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.84);
}

.purchase-footer-total strong {
    color: #ffffff;
    font-size: 0.9rem;
}

.purchase-footer-right {
    display: flex;
    align-items: center;
    gap: 12px;
}

.purchase-footer-right .ant-btn {
    height: 34px;
    padding: 0 16px;

    display: flex;
    align-items: center;
    gap: 6px;

    border: 0;
    border-radius: 8px;

    font-size: 0.8rem;
    font-weight: 600;

    transition: all 0.2s;
}

.create_button {
    background: #ff432d;
    color: #ffffff;
}

.purchase-footer-right .ant-btn:hover,
.purchase-footer-right .ant-btn:focus {
    background: #ff5a47;
    color: #ffffff;
}
.status-tag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 2px 10px;
    border-radius: 999px;
    font-size: 0.7rem;
    font-weight: 500;
    white-space: nowrap;
}

.status-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    flex-shrink: 0;
}

::v-deep(.ant-statistic-title) {
    font-size: 0.7rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.search-group {
    display: flex !important;
    width: 100%;
}

.search-group-input {
    flex: 1;
    min-width: 0;
}

.search-group .ant-select,
.search-group .ant-input-affix-wrapper,
.search-group .ant-input {
    width: 100%;
}

.search-group .ant-input-affix-wrapper {
    border-left-width: 0 !important;
}

.search-group .ant-select-selector,
.search-group .ant-input-affix-wrapper,
.search-group .ant-input {
    height: 32px !important;
}

.search-group .ant-input {
    height: 30px !important;
}
.diagnosis-table > tr > th {
    text-align: left !important;
}
.curve-group {
    display: flex !important;
    width: 100%;
}

.curve-group .ant-select {
    flex: 1;
    min-width: 0;
}

.curve-group .ant-select-selector {
    width: 100% !important;
}
.ant-table-cell-fix-left,
.ant-table-cell-fix-right {
    background: #fff;
}
::v-deep(.ant-table-fixed-left) {
    z-index: 2;
}
.ant-table-cell-fix-left-last::after {
    box-shadow: inset 10px 0 8px -8px rgba(0, 0, 0, 0.08);
}
.curve-inline {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    min-width: 0;
}

.curve-cell {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.curve-main {
    font-weight: 500;
    line-height: 1.2;
}

.curve-tag {
    padding: 4px 6px;
    border-radius: 5px;
    font-size: 10px;
    font-weight: 600;
    line-height: 1;
}

.curve-a {
    background: #fff1f0;
    color: red;
}

.curve-b {
    background: #dff4ff;
    color: blue;
}

.curve-c {
    background: #e7e7e7;
    color: black;
}

.curve-d {
    background: #f5f5f5;
    color: #595959;
}

.range-values {
    display: flex;
    justify-content: space-between;
    margin-top: 4px;
    font-size: 12px;
    color: #8c8c8c;
}

.page-card {
    margin-bottom: 10px;
    width: 100%;
}

.table-container {
    width: 100%;
    overflow-y: visible;
    max-height: 60vh;
}

.actions-col {
    display: flex;
    align-items: flex-end;
}

.actions-right {
    margin-left: auto;
    display: flex;
    gap: 8px;
    margin-left: auto;
    justify-content: flex-end;
}

.filters-card {
    margin: 10px 0;
}

::v-deep(.ant-input) {
    padding: 0 !important;
}

::v-deep(.ant-input-number-input:placeholder-shown) {
    padding: 0 !important;
}
.totals-card {
    background: #fafafa;
}

.table-card {
    overflow: hidden;
}

.table-overflow {
    width: 100%;
}
::v-deep td.centered-column,
::v-deep th {
    text-align: center !important;
    align-items: center !important;
}
.coverage-cell {
    margin-left: auto;
    margin-right: auto;
    display: flex;
    align-items: center;
    gap: 1px;
    width: 100%;
    max-width: 60px;
}

.coverage-progress {
    flex: 1;
    max-width: 30px;
    min-width: 30px;
    margin-bottom: 0 !important;
}

.coverage-text {
    color: #595959;
    white-space: nowrap;
    flex-shrink: 0;
    margin-left: auto;
    text-align: right;
}
.winners-page-options-select-option:hover {
    background-color: var(--primary-color);
    border-radius: 5px;
    color: white;
}
.winners-page-options-select-option {
    font-size: 1rem;
    padding: 0.5vh;
    min-width: 15vw;
    text-align: end;
    cursor: pointer;
}
.winners-page-options-select {
    position: absolute;
    z-index: 2;
    margin-top: 1vh;
    right: 0;
    padding: 0.5vw;
    border-radius: 5px;
    border: 1px solid #e5e5e5;
    background-color: white;
}
.buttons-container {
    flex-direction: row-reverse;
    display: flex;
    gap: 10px;
}
.filter-container {
    display: block;
    flex-direction: row-reverse;
    margin-right: 40px;
    gap: 10px;
    margin-right: auto;
    width: 100%;
}

.page-route-select {
    display: flex;
    align-items: center;
}
.page-route-select-text {
    font-weight: 400;
    font-size: 1.36em;
    color: #ababab;
    margin-right: 20px;
    cursor: pointer;
}
.page-route-select-icon {
    color: var(--primary-color);
    margin-right: 20px;
}
.page-title {
    font-weight: 600;
    font-size: 2.72em;
    letter-spacing: 0.15px;
    color: #605f5f;
    margin-top: 40px;
}
.page {
    font-size: 1rem;
    overflow-x: hidden;
}
.page-buttons-containear {
    display: flex;
    align-items: flex-end;
    margin-top: 3vh;
}
.page-button {
    margin-left: 3vw;
}
.page-table {
    margin-top: 6vh;
}
.table-row-separator {
    border-right: 0.5px solid #dde5e9;
}
.page-table-header {
    display: flex;
    background: #fffefc;
    border: 0.5px solid #e5e5e5;
    padding: 1vh 0;
    margin-bottom: 2vh;
}
.page-colum-width {
    width: 15%;
    text-align: center;
}
.page-colum-width-checkbox {
    width: 5%;
    display: flex;
    justify-content: center;
}
.page-table-row {
    display: flex;
    padding: 1.5vh 0;
    font-size: 0.8rem;
}
.page-header-text {
    font-weight: 600;
    font-size: 1rem;
    color: #605f5f;
}
.table-row-text-1 {
    font-weight: 300;
    font-size: 1rem;
    color: #605f5f;
}
.table-row-text-2 {
    font-weight: 500;
    font-size: 1rem;
    color: #afafaf;
}
.checkbox-icon-containear {
    margin-left: 1vw;
    padding-right: 1vw;
    color: var(--primary-color);
    cursor: pointer;
    font-size: 1.7em;
}
.page-table-line-special {
    background: #f7f7f7;
}
.mobile-tab-mobile-header {
    display: none;
}
.table-product-button {
    background: rgba(23, 162, 184, 0.05);
    border-radius: 8px;
    margin: 0 50px;
    width: 10vw;
    color: #17a2b8;
    cursor: pointer;
}
.status-button {
    width: 20vw;
}
.mobile {
    display: none;
}

@media (max-width: 850px) {
    .ant-table-scroll > .ant-table-body > table > thead,
    .ant-table-fixed-left,
    .ant-table-fixed-right,
    #title-card > .ant-card-body {
        display: none;
    }
    .page-buttons-containear {
        flex-direction: column;
        align-items: stretch;
    }
    .mobile {
        display: flex;
    }
    .page-button {
        margin-left: 0;
        margin-top: 2vh;
    }
    .status-button {
        width: 100%;
    }

    .page {
        font-size: 2.5vw;
    }
    .page-table-header {
        display: none;
    }
    .page-table-row {
        flex-direction: column;
        margin-top: 3vh;
        gap: 1vh;
        font-size: 1.5em;
    }
    .page-colum-width {
        display: flex;
        width: 100%;
        flex: unset;
        justify-content: space-between;
    }
    .mobile-tab-mobile-header {
        display: flex;
        font-weight: 700;
        font-size: 1.1em;
        color: #605f5f;
    }
    .table-product-button {
        margin: 0;
        width: 15vw;
        text-align: center;
        border: 1px solid #17a2b8;
    }
    .table-row-separator {
        border-right: 0;
    }

    @import "../monitors.page";

    /deep/ .buttons {
        a {
            margin-left: 10px;
        }
    }
    .checkBoxTableHeader {
        margin-left: 0px !important;
    }
    .button-alter {
        cursor: pointer;
        font-size: 1.7em;
    }
    .page-colum-width-checkbox {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        gap: 3vw;
    }
    .mobile-table-row {
        justify-content: space-between;
        width: 100%;
    }
    .mobile-flex-end {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }
    .mobile-line-container {
        display: flex;
        gap: 2vw;
    }
    .desktop {
        display: none;
    }
}

//MODAL
.purchase-modal ::v-deep(.ant-table-wrapper) {
    width: auto;
}
.purchase-modal ::v-deep(.ant-modal-body) {
    height: 75vh;
    overflow: hidden;
    padding: 16px 0;
}
.purchase-modal-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.purchase-modal-total {
    font-size: 1rem;
    color: #262626;
}

.purchase-modal-total strong {
    font-size: 1.1rem;
}
.purchase-modal-layout {
    display: flex;
    gap: 2px;
    height: 100%;
}

.purchase-modal-left {
    flex: 1 1 auto;
    min-width: 0;

    overflow-y: auto;
    overflow-x: hidden;
}

.purchase-modal-right {
    width: clamp(220px, 22vw, 300px);

    display: flex;
    flex-direction: column;

    gap: 12px;

    flex-shrink: 0;

    height: 100%;

    min-height: 0;

    padding: 20px;

    color: #868686;

    background-color: #fafafa;
}
.summary-card {
    background: #22252a;
    border-radius: 10px;
    padding: 12px;
}

.summary-title {
    font-size: 0.9rem;
    margin-bottom: 10px;
    font-weight: 600;
}

.summary-item {
    display: flex;
    justify-content: space-between;
    font-size: 0.8rem;
    padding: 4px 0;
}

.summary-item.highlight {
    margin-top: 6px;
    padding-top: 8px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
}
.store-summary-card {
    background: #fff;
    border-radius: 10px;
    padding: 12px;
    border: 1px solid #eee;

    flex: 1;

    min-height: 0;

    overflow-y: auto;
    overflow-x: hidden;
}

.store-summary-item {
    display: flex;
    justify-content: space-between;
    font-size: 0.8rem;
    padding: 6px 0;
    border-bottom: 1px dashed #eee;
}

.store-summary-item:last-child {
    border-bottom: none;
}
.purchase-request-name {
    margin-bottom: 18px;
}

.purchase-request-label {
    font-size: 11px;
    font-weight: 600;
    color: #858586;

    margin-bottom: 2px;
    letter-spacing: 0.6px;
}
</style>
